export const GAMEDATA_PART2 = [
    {
        "_id": {
            "$oid": "62f478fe7182babb3abe4e1a"
        },
        "name": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe ô tô?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-động-cơ-ô-tô-đã-khởi-động,-bảng-đồng-hồ-xuất-hiện-ký-hiệu-như-hình-vẽ-dưới-đây,-báo-hiệu-tình-trạng-như-thế-nào-của-xe-ô-tô?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Khi động cơ ô tô đã khởi động, bảng đồng hồ xuất hiện ký hiệu như hình vẽ dưới đây, báo hiệu tình trạng như thế nào của xe ô tô?",
        "images": [
            "/assets/images/luatgiaothong/den_bao_hieu_phay_tay_thieu_dau.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/den_bao_hieu_phay_tay_thieu_dau.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "Hình Ảnh",
        "grade": "4",
        "leaderSkill": "Phanh tay đang hãm hoặc thiếu dầu phanh",
        "skill1": "Phanh tay đang hãm hoặc thiếu dầu phanh",
        "skill2": "Nhiệt độ nước làm mát quá mức cho phép",
        "skill3": "Cửa xe đang mở",
        "created": {
            "$date": "2022-08-11T03:35:26.723Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:35:26.724Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f4795e7182babb3abe4e1f"
        },
        "name": "Khi điều khiển xe ô tô ra khỏi đường cao tốc người lái xe cần thực hiện như thế nào dưới đây để bảo đảm an toàn giao thông?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "khi-điều-khiển-xe-ô-tô-ra-khỏi-đường-cao-tốc-người-lái-xe-cần-thực-hiện-như-thế-nào-dưới-đây-để-bảo-đảm-an-toàn-giao-thông?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Khi điều khiển xe ô tô ra khỏi đường cao tốc người lái xe cần thực hiện như thế nào dưới đây để bảo đảm an toàn giao thông?",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "All",
        "grade": "4",
        "leaderSkill": "Quan sát phía trước để tìm biển báo chỉ dẫn “Lối ra đường cao tốc”, kiểm tra tình trạng giao thông phía sau và bên phải, nếu đảm bảo điều kiện an toàn thì phát tín hiệu và điều khiển xe chuyển dần sang làn đường giảm tốc và ra khỏi đường cao tốc",
        "skill1": "Quan sát phía trước để tìm biển báo chỉ dẫn “Lối ra đường cao tốc”, kiểm tra tình trạng giao thông phía sau và bên phải, nếu đảm bảo điều kiện an toàn thì phát tín hiệu và điều khiển xe chuyển dần sang làn đường giảm tốc và ra khỏi đường cao tốc",
        "skill2": "Quan sát về phía trước để tìm biển báo chỉ dẫn “Lối ra đường cao tốc”, trường hợp vượt qua “Lối ra đường cao tốc” thì phát tín hiệu, di chuyển sang làn đường giảm tốc và lùi xe quay trở lại",
        "skill3": "",
        "created": {
            "$date": "2022-08-11T03:37:02.234Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:37:02.236Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "62f479907182babb3abe4e22"
        },
        "name": "Xe nào vi phạm quy tắc giao thông?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "xe-nào-vi-phạm-quy-tắc-giao-thông?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Xe nào vi phạm quy tắc giao thông?",
        "images": [
            "/assets/images/luatgiaothong/hinhanh_xecon_vipham.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/hinhanh_xecon_vipham.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "Hình Ảnh",
        "grade": "4",
        "leaderSkill": "Xe con",
        "skill1": "Xe khách",
        "skill2": "Mô tô",
        "skill3": "Xe con",
        "skill4": "Xe con và mô tô",
        "created": {
            "$date": "2022-08-11T03:37:52.861Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:38:38.907Z"
        },
        "__v": 0,
        "image1": "/assets/images/luatgiaothong/hinhanh_xecon_vipham.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/luatgiaothong/hinhanh_xecon_vipham.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62f47a357182babb3abe4e2c"
        },
        "name": "Biển x này có ý nghĩa gì?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "biển-x-này-có-ý-nghĩa-gì?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Biển x này có ý nghĩa gì?",
        "images": [
            "/assets/images/luatgiaothong/bien_bao_hieu_cam_dungdo_xe_benphai.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/bien_bao_hieu_cam_dungdo_xe_benphai.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "Hình Ảnh",
        "grade": "4",
        "leaderSkill": "Cấm đỗ xe và cấm dừng xe theo hướng bên phải",
        "skill1": "Cấm dừng xe về hướng bên trái",
        "skill2": "Cấm đỗ xe và cấm dừng xe theo hướng bên phải",
        "skill3": "Được phép đỗ xe và dừng xe theo hướng bên phải",
        "skill4": "",
        "created": {
            "$date": "2022-08-11T03:40:37.487Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:41:49.531Z"
        },
        "__v": 0,
        "image1": "/assets/images/luatgiaothong/bien_bao_hieu_cam_dungdo_xe_benphai.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/luatgiaothong/bien_bao_hieu_cam_dungdo_xe_benphai.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "62f47acb7182babb3abe4e33"
        },
        "name": "Trong các biển báo dưới đây biển nào báo hiệu “Hết đường cao tốc?",
        "category": "luat_gtvt",
        "subCategory": "question",
        "slug": "trong-các-biển-báo-dưới-đây-biển-nào-báo-hiệu-“hết-đường-cao-tốc?",
        "rate": 4,
        "price": 1,
        "quantity": 4,
        "description": "Trong các biển báo dưới đây biển nào báo hiệu “Hết đường cao tốc?",
        "images": [
            "/assets/images/luatgiaothong/bien_bao_hieu_het_duong_cao_toc.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/luatgiaothong/bien_bao_hieu_het_duong_cao_toc.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "LyThuyet",
        "species": "B2",
        "type": "Hình Ảnh",
        "grade": "4",
        "leaderSkill": "Biển 2",
        "skill1": "Biển 1",
        "skill2": "Biển 2",
        "skill3": "Biển 3",
        "skill4": "",
        "created": {
            "$date": "2022-08-11T03:43:07.534Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-08-11T03:43:07.536Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6318138398f4fe6e727a33d1"
        },
        "name": "Unlimited Power",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "unlimited-power",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies and stuns for 1 turn if there are 4 or more enemies. The damage increases the higher the enemy's current HP. Attacks the selected target 6 times if there are 3 or fewer enemies and deals damage that ignores Defense up to 100% the lower the target's current HP. (Reusable in 5 turns).\nMultiplier: {ATK}*(2.5*{Target Current HP %} + 3.5) x6",
        "images": [
            "/assets/images/skills/skill3/Unlimited_Power.png",
            "/assets/images/skills/Stun.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Unlimited_Power.png",
            "/assets/images/skills/Stun.png"
        ],
        "element": "Water",
        "species": "Weapon Master",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T03:44:03.193Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T03:44:03.196Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63183a442c2a079557a85c41"
        },
        "name": "Noble Agreement",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "noble-agreement",
        "rate": 5,
        "price": 2,
        "quantity": 2,
        "description": "Strikes two strong blows. This attack receives a 30% Critical Rate bonus. (Reusable in 3 turns)\nMultiplier: 295% x2",
        "images": [
            "/assets/images/skills/skill1/Noble_Agreement_Fire.png",
            "/assets/images/skills/skill1/Noble_Agreement_Light.png.png",
            "/assets/images/skills/Increase-CRI-Rate.png",
            "/assets/images/skills/Stun.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Noble_Agreement_Fire.png",
            "/assets/images/skills/skill1/Noble_Agreement_Light.png.png"
        ],
        "element": "Skill",
        "species": "Vampire",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:29:24.143Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:37:08.197Z"
        },
        "__v": 0,
        "image1": "/assets/images/skills/skill1/Noble_Agreement_Fire.png",
        "image2": "/assets/images/skills/skill1/Noble_Agreement_Light.png.png",
        "image3": "/assets/images/skills/Increase-CRI-Rate.png",
        "image4": "/assets/images/skills/Stun.png",
        "thumbImage1": "/assets/images/skills/skill1/Noble_Agreement_Fire.png",
        "thumbImage2": "/assets/images/skills/skill1/Noble_Agreement_Light.png.png"
    },
    {
        "_id": {
            "$oid": "63183aaf2c2a079557a85c44"
        },
        "name": "Boiling Blood",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "boiling-blood",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Your Critical Hits increase the Attack Bars of all allies by 20%. This effect does not have effect on allies that have similar skill effects. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Boiling_Blood_Passive.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Boiling_Blood_Passive.png",
            "/assets/images/skills/attack-bar-up.png"
        ],
        "element": "Fire",
        "species": "Vampire",
        "type": "Passive",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:31:11.388Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T09:43:28.187Z"
        },
        "__v": 0,
        "image1": "/assets/images/skills/skill3/Boiling_Blood_Passive.png",
        "image2": "/assets/images/skills/attack-bar-up.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/skills/skill3/Boiling_Blood_Passive.png",
        "thumbImage2": "/assets/images/skills/attack-bar-up.png"
    },
    {
        "_id": {
            "$oid": "63183b182c2a079557a85c47"
        },
        "name": "Killing Wave",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "killing-wave",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks all enemies 5 times, which always land as a Critical Hit on the Fire Monsters, with each attack having a 20% chance to decrease their Defense for 2 turns. The damage increases as the enemy's HP status decreases. (Reusable in 5 turns).\nMultiplier: {ATK}*(1.5 - 0.5*{Target Current HP %}) x5",
        "images": [
            "/assets/images/skills/skill3/Killing_Wave.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Killing_Wave.png",
            "/assets/images/skills/Reduce-DEF.png"
        ],
        "element": "Water",
        "species": "Vampire",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:32:56.464Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:32:56.465Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63183b502c2a079557a85c4a"
        },
        "name": "Death Blow",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "death-blow",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy target 3 times with each attack having a 20% chance to leave a Branding Effect for 2 turns. The damage increases by 25% for each harmful effect on the enemy. (Reusable in 4 turns).\nMultiplier: 3.0*{ATK} x3",
        "images": [
            "/assets/images/skills/skill3/Death_Blow.png",
            "/assets/images/skills/Brand1.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Death_Blow.png",
            "/assets/images/skills/Brand1.png"
        ],
        "element": "Wind",
        "species": "Vampire",
        "type": "Active",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:33:52.2Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:33:52.2Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63183b982c2a079557a85c4d"
        },
        "name": "Immortality",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "immortality",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "At the moment of death, you regain HP by absorbing 10% from all other allies. HP cannot be absorbed from allies that are at 30% HP or lower. [Automatic Effect]",
        "images": [
            "/assets/images/skills/skill3/Immortality_Passive.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Immortality_Passive.png",
            "/assets/images/products/clothes/3.png"
        ],
        "element": "Light",
        "species": "Vampire",
        "type": "Passive",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:35:04.396Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:35:04.397Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63183bdd2c2a079557a85c50"
        },
        "name": "Feast of Blood",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "feast-of-blood",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks leave a Branding Effect that lasts for 2 turns and heal all allies for 30% of the damage done. Also, absorbs the Attack Bar of the enemy by 20% with each attack. [Automatic Effect] ",
        "images": [
            "/assets/images/skills/skill3/Feast_of_Blood_Passive.png",
            "/assets/images/skills/Brand1.png",
            "/assets/images/skills/attack-bar-up.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill3/Feast_of_Blood_Passive.png",
            "/assets/images/skills/Brand1.png"
        ],
        "element": "Dark",
        "species": "Vampire",
        "type": "Passive",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:36:13.433Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:36:13.434Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63183e5b2c2a079557a85c6f"
        },
        "name": "Vampire Lord - Weaken",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "vampire-lord---weaken",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks the enemy 3 times. Each attack weakens the enemy's Attack Power, decreases the enemy's Attack Speed and blocks beneficial effects for 2 turns with a 75% chance each. (Reusable in 4 turns)\nMultiplier: 230% x3",
        "images": [
            "/assets/images/skills/skill2/VampireLord_Weaken1.png",
            "/assets/images/skills/skill2/VampireLord_Weaken2.png",
            "/assets/images/skills/Reduce-ATK.png",
            "/assets/images/skills/Block-Beneficial-Effects.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/VampireLord_Weaken1.png",
            "/assets/images/skills/Reduce-Speed.png"
        ],
        "element": "Dark",
        "species": "Vampire Lord",
        "type": "Skill",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:46:51.64Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:46:51.641Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63183ede2c2a079557a85c76"
        },
        "name": "Vampire Lord - Vampire Bat",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "vampire-lord---vampire-bat",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks 2 times with a vampire bat and recovers HP by 30% of the inflicted damage.\nMultiplier: 200% x2",
        "images": [
            "/assets/images/skills/skill1/VampireLord_Vampire_Bat.png",
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/1.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/VampireLord_Vampire_Bat.png",
            "/assets/images/products/clothes/1.png"
        ],
        "element": "Dark",
        "species": "Vampire Lord",
        "type": "Skill",
        "grade": "5",
        "created": {
            "$date": "2022-09-07T06:49:02.687Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-07T06:49:02.687Z"
        },
        "__v": 0
    },
    {
        "_id": {
            "$oid": "631af191622383152e4f8ce1"
        },
        "name": "Hình Đạo Vinh",
        "category": "tsonline",
        "subCategory": "heroes",
        "slug": "hình-đạo-vinh",
        "rate": 2,
        "price": 1,
        "quantity": 1,
        "description": "Hình Đạo Vinh – Xing DaoRong – 邢道榮\n\nHình Đạo Vinh là một nhân vật hư cấu trong tiểu thuyết Tam Quốc Diễn Nghĩa của La Quán Trung. Trong truyện, ông là bộ tướng của Lưu Hiền, con trai Lưu Độ, một tướng thời Đông Hán đóng ở Kinh Châu.\n\nSau trận Xích Bích, Lưu Bị lấy danh nghĩa Lưu Kỳ, con trai Lưu Biểu để bình định 4 quận Kinh Nam. Nghe tin, thái thú Linh Lăng là Lưu Độ tự tin vẫn còn mãnh tướng “sức địch trăm người” là Hình Đạo Vinh, và cử ông này cùng hơn vạn quân ra nghênh chiến.\n\nSau khi hai bên dàn trận xong, Hình Đạo Vinh tay cầm búa Khai Sơn quát mắng, Gia Cát Lượng quát lại mà rằng Tào Tháo mang 10 vạn quân ông đây chỉ dùng 1 mẹo nhỏ còn đánh cho không còn mảnh giáp, dăm ba lính lẻ sao không đầu hàng cho lẹ. Hinh Đạo Vinh khịa lại, kế đó của Chu Du chứ nào của người mà khoác lác.\n\nNói rồi Hinh Đạo Vinh vác búa xông lên đánh, Gia Cát Lượng rút về trận đạo. Vinh xông vào thì dính trận địa, bị Trương Phi và Triệu Vân bao vây, nhắm địch không nổi phải xuống ngựa đầu hàng.\n\nLưu Bị sai chém, nhưng Gia Cát Lượng ngăn lại, khơi lên nếu bắt được Lưu Hiền thì cho hàng, Hình Đạo Vinh vội vàng xin đi và được Gia Cát Lượng đồng ý thả về.\n\nHình Đạo Vinh về đến Linh Lăng kể lại toàn bộ sự việc cho Lưu Hiền và âm mưu lập kế phản gián. Nhưng tất cả đã được Gia Cát Lượng dự định sẵn, Hinh Đạo Vinh cùng Lưu Hiền trúng kế, đuổi theo quân Thục đang rút chạy thì gặp quân mai phục. Hình Đạo Vinh bị Triệu Vân chém chết, còn Lưu Hiền vội vã đầu hàng quân Thục.\n\nTrong TS Online, sự kiện bình định Kinh Nam của quân Thục được gói gọn trong diễn biến thu phục hổ tướng Hoàng Trung, nên các nhân vật Lưu Độ, Lưu Hiền và Hình Đạo Vinh cũng chỉ nhắc tới trong một phần diễn biến sự kiện này.\nThông tin võ tướng trong game\n\nTên: Hình Đạo Vinh\n\nHệ: Hoả\n\nPhe/ Doanh Trận: Du Hiệp – Lưu Hiền\n\nLevel NPC: 81\n\nThuộc tính thuần: ATK\n\nKỹ năng cơ bản: Hoả Cầu – Hội Tâm Nhất Kích – Phong Hoả Luân\n\nXuất hiện: Lung Linh thành môn – Kinh Châu (Nam)\n\nMột số Quest tiêu biểu xuất hiện: Trọng nghĩa Hoàng Trung",
        "images": [
            "/assets/images/heroes/tsonline/hinh_dao_vinh.png",
            "https://badauyeu.com/wp-content/uploads/2022/04/Untitled-1018x486.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/tsonline/hinh_dao_vinh.png",
            "/assets/images/products/clothes/3.png"
        ],
        "element": "Fire",
        "species": "Kinh Châu",
        "type": "Attack",
        "grade": "2",
        "created": {
            "$date": "2022-09-09T07:56:01.978Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:15:45.535Z"
        },
        "__v": 0,
        "image1": "/assets/images/heroes/tsonline/hinh_dao_vinh.png",
        "image2": "https://badauyeu.com/wp-content/uploads/2022/04/Untitled-1018x486.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/heroes/tsonline/hinh_dao_vinh.png",
        "thumbImage2": "/assets/images/products/clothes/3.png"
    },
    {
        "_id": {
            "$oid": "632156987c763a50a6ae5368"
        },
        "name": "Diamonds",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "diamonds",
        "rate": 5,
        "price": 500,
        "quantity": 1,
        "description": "Diamonds are a very important currency in afkarena. There are many ways to obtain diamonds, both for free and for money. ",
        "images": [
            "/assets/images/items/afkarena/Icon_bag_diamond.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Icon_bag_diamond.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:20:40.13Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:14:38.847Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Icon_bag_diamond.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Icon_bag_diamond.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632156cf7c763a50a6ae536b"
        },
        "name": " Time Emblem",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "-time-emblem",
        "rate": 5,
        "price": 10,
        "quantity": 1,
        "description": "Can be used at the Temple of Time to draw prizes from the prize pool Accumulating 10 cards allows uou to draw ouy 10 prizes at once. Complete stage 16-1 or reach VIP level 13 to unlock the Temple of Time",
        "images": [
            "/assets/images/items/afkarena/Hypergacha_ticket_item.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Hypergacha_ticket_item.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:21:35.666Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:14:11.895Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Hypergacha_ticket_item.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Hypergacha_ticket_item.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6321574b7c763a50a6ae536e"
        },
        "name": "Elite soulstones",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "elite-soulstones",
        "rate": 5,
        "price": 60,
        "quantity": 1,
        "description": "In afkarena you can acquire 3 types of Soulstones: purple Elite soulstones, elite and rare Hero soulstones and blue Rare soulstones. You need 60 of them to summon Elite hero from Elite ones or Rare hero from Rare stones. Hero soulstones are currenly available only in Store and summon certain hero (e.g. 60 Shemira soulstones summon an elite Shemira)",
        "images": [
            "/assets/images/items/afkarena/Combine_stone.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Combine_stone.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:23:39.757Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:13:33.769Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Combine_stone.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Combine_stone.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632157667c763a50a6ae5371"
        },
        "name": "Rare soulstones",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "rare-soulstones",
        "rate": 5,
        "price": 60,
        "quantity": 1,
        "description": "While summoning elite hero you should know, it's not necessary has to be ascended tier hero (e.g. you can get Elite Vedan from 60 Elite soulstones). ",
        "images": [
            "/assets/images/items/afkarena/Combine_stone_2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Combine_stone_2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:24:06.803Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:13:08.514Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Combine_stone_2.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Combine_stone_2.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632157a47c763a50a6ae5374"
        },
        "name": "A Common Scroll",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "a-common-scroll",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Common Scrolls are used for a specific tab in The Noble Tavern called Produces All Heroes. There, players are able to exchange Common Scrolls for Hero Cards. ",
        "images": [
            "/assets/images/items/afkarena/Draw_ticket_normal.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Draw_ticket_normal.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:25:08.153Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:10:38.767Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Draw_ticket_normal.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Draw_ticket_normal.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632157bc7c763a50a6ae5377"
        },
        "name": "A Faction Scroll",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "a-faction-scroll",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Faction Scrolls are used for a specific tab in The Noble Tavern called Faction Pack . There, players are able to exchange Faction Scrolls for Hero Cards of a specific Faction.",
        "images": [
            "/assets/images/items/afkarena/Draw_ticket_special.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Draw_ticket_special.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:25:32.828Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:10:17.496Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Draw_ticket_special.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Draw_ticket_special.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632157dc7c763a50a6ae537a"
        },
        "name": "Gold",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "gold",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Gold is the most widely used currency in Esperia. Players can use gold to level their heroes, upgrade their gear, buy items in the in-game store, level up their Resonating Crystal. While gold is quite easily earnable it's also very vital to many game activities.",
        "images": [
            "/assets/images/items/afkarena/Icon_bag_gold.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Icon_bag_gold.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:26:04.564Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:09:54.361Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Icon_bag_gold.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Icon_bag_gold.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632157fa7c763a50a6ae537d"
        },
        "name": " Hero's Essence",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "-hero's-essence",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Hero's Essence (commonly referred to as Dust) is an essential substance needed to level up your heroes and then your Resonating Crystal. You will need this resource for some certain hero levels (the ones giving your hero skill upgrades, e.g. 81, 121, 201) and after leveling 5 heroes to level 240, you will need hero essence for every level of Resonating Crystal.",
        "images": [
            "/assets/images/items/afkarena/Icon_bag_dust.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Icon_bag_dust.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:26:34.542Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:09:28.175Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Icon_bag_dust.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Icon_bag_dust.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632158127c763a50a6ae5380"
        },
        "name": " Hero Experience",
        "category": "afkarena",
        "subCategory": "Item",
        "slug": "-hero-experience",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Hero Experience (commonly known as Hero's EXP) is one of the primary resources used to level up your heroes in afkarena. ",
        "images": [
            "/assets/images/items/afkarena/Xp.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/items/afkarena/Xp.png",
            "/assets/images/products/clothes/2.png"
        ],
        "element": "Item",
        "species": "Item",
        "type": "Item",
        "grade": "5",
        "created": {
            "$date": "2022-09-14T04:26:58.441Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:08:33.94Z"
        },
        "__v": 0,
        "image1": "/assets/images/items/afkarena/Xp.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "thumbImage1": "/assets/images/items/afkarena/Xp.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "632159317c763a50a6ae5383"
        },
        "name": "Lucius",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "lucius",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Lucius is a strength-based tank hero of the Lightbearer faction. His skills are focused on stalling the enemies in front of him. He also has skills which can heal allied members as well as give himself a strong shield to boost his defense.\n\nLucius' ultimate ability \"Heaven's Protection\" casts a shield around his allies, mitigating damage briefly. ",
        "images": [
            "/assets/images/heroes/afkarena/Lucius.png",
            "/assets/images/heroes/afkarena/LuciusCard.png",
            "/assets/images/heroes/afkarena/The_Mariner_Model.png",
            "/assets/images/heroes/afkarena/Lucius_Model.png"
        ],
        "thumbImage": [
            "/assets/images/heroes/afkarena/Lucius.png",
            "/assets/images/heroes/afkarena/LuciusCard.png"
        ],
        "element": "Lightbearer",
        "species": "Defense",
        "type": "Strength",
        "grade": "5",
        "leaderSkill": "The Winged Protector",
        "skill1": "Heaven's Protection",
        "skill2": "Divine Strike",
        "skill3": "Divine Blessing",
        "skill4": "Blessed Shield",
        "created": {
            "$date": "2022-09-14T04:31:45.423Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "active": true,
        "modified": {
            "$date": "2022-09-14T07:08:20.977Z"
        },
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Lucius.png",
        "image2": "/assets/images/heroes/afkarena/LuciusCard.png",
        "image3": "/assets/images/heroes/afkarena/The_Mariner_Model.png",
        "image4": "/assets/images/heroes/afkarena/Lucius_Model.png",
        "thumbImage1": "/assets/images/heroes/afkarena/Lucius.png",
        "thumbImage2": "/assets/images/heroes/afkarena/LuciusCard.png"
    },
    {
        "_id": {
            "$oid": "632d0e3371b3d05f2ce4e744"
        },
        "name": "sudoku by Hao 1",
        "category": "sudoku",
        "subCategory": "sudoku_hard",
        "slug": "sudoku-by-hao-1",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/sudoku/hao_1.jpg",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "hard",
        "species": "sudoku",
        "type": "9x9",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-23T01:38:59.678Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "632d0f1a71b3d05f2ce4e74d"
        },
        "name": "sudoku 4422",
        "category": "sudoku",
        "subCategory": "sudoku_hard",
        "slug": "sudoku-4422",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/sudoku/4422_egdh.jpg",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "hard",
        "species": "sudoku",
        "type": "9x9",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-23T01:42:50.598Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "632d0f4071b3d05f2ce4e750"
        },
        "name": "sudoku 4181",
        "category": "sudoku",
        "subCategory": "sudoku_hard",
        "slug": "sudoku-4181",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/sudoku/4181_bnsg.jpg",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "hard",
        "species": "sudoku",
        "type": "9x9",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-23T01:43:28.496Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "632d0f5b71b3d05f2ce4e753"
        },
        "name": "sudoku 4177",
        "category": "sudoku",
        "subCategory": "sudoku_hard",
        "slug": "sudoku-4177",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/sudoku/4177_chss.jpg",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "hard",
        "species": "sudoku",
        "type": "9x9",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-23T01:43:55.256Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "632d15c471b3d05f2ce4e77c"
        },
        "name": "sudoku 4201",
        "category": "sudoku",
        "subCategory": "sudoku_hard",
        "slug": "sudoku-4201",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/sudoku/4201_rsff.jpg",
            "/assets/images/sudoku/4201_rsff_result.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/3.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "hard",
        "species": "sudoku",
        "type": "9x9",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-23T02:11:16.125Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "633174e9ee29e037dd9cbf3f"
        },
        "name": "Chill Skybar",
        "title": "Chill Skybar",
        "city": "hochiminh",
        "category": "realestate",
        "subCategory": "restaurants",
        "slug": "chill-skybar",
        "rate": 5,
        "price": 550,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information666",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "carouselImages": [
            "vRZ24bTjikBxbRl6HgQH"
        ],
        "galleryThumbnails": [
            "k0nZWu1QXmR7uCj15jIV"
        ],
        "sliderImages": [
            "7DVLMbQHToWN0fM7RW5V"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-26T09:46:17.949Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "active",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T04:16:57.64Z"
        },
        "keywords": "",
        "ApiKey": null,
        "FacebookURL": null,
        "InstagramURL": null,
        "LinkedinURL": null,
        "TwitterURL": null,
        "address": null,
        "email": null,
        "mapLatitude": null,
        "mapLongitude": null,
        "phone": null,
        "promoVideoVimeo": null,
        "promoVideoYoutube": null,
        "videoVimeo": null,
        "videoYoutube": null,
        "website": null
    },
    {
        "_id": {
            "$oid": "633693b6bdae9dd9d21feea7"
        },
        "name": "Cafe Des Stagiares",
        "title": "Cafe Des Stagiares",
        "city": "hochiminh",
        "category": "realestate",
        "subCategory": "restaurants",
        "slug": "cafe-des-stagiares",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "carouselImages": [
            "IhEZZatQLSGsYEfpzSNr"
        ],
        "galleryThumbnails": [
            "n1f0fuCaSPeJcYGGDR59"
        ],
        "sliderImages": [
            "0Au5bVRGTCCjrgLUnjIE"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-09-30T06:59:02.302Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "active",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T04:12:43.868Z"
        },
        "address": "HCM",
        "keywords": "",
        "ApiKey": null,
        "FacebookURL": null,
        "InstagramURL": null,
        "LinkedinURL": null,
        "TwitterURL": null,
        "email": null,
        "mapLatitude": null,
        "mapLongitude": null,
        "phone": null,
        "promoVideoVimeo": null,
        "promoVideoYoutube": null,
        "videoVimeo": null,
        "videoYoutube": null,
        "website": null
    },
    {
        "_id": {
            "$oid": "6350c7761846e49d08a6a042"
        },
        "name": "A",
        "category": "Sushi Tí",
        "subCategory": "Sashimi",
        "slug": "a",
        "rate": 5,
        "price": 1,
        "quantity": 10,
        "description": "A1",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1SwAMLc6-QB9ICasb7DKGjfKv833vX8i3",
            "https://drive.google.com/uc?export=view&id=1ea0d5tSNtWrV9_3X7H6LwErCfxRn9DGP",
            "https://drive.google.com/uc?export=view&id=1W6isdzcV6y4sGKu1ofrpAyKTo7-WVPNW",
            "1.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hxttFViMhTnvvzZs3_Hwd-gjAILv2-D4",
            "https://drive.google.com/uc?export=view&id=1t7xL4jfWYBaUnJl5l9AOOqe9uXhGYJDt"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "species": "A1",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-20T03:58:46.022Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-10-20T06:11:03.552Z"
        }
    },
    {
        "_id": {
            "$oid": "6350c8091846e49d08a6a057"
        },
        "name": "2",
        "category": "Sushi Tí",
        "subCategory": "Salad",
        "slug": "2",
        "rate": 5,
        "price": 2,
        "quantity": 10,
        "description": "2",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1zLhC1A4W2dJNWrd1NVwm1uxpxH3MJ-gU",
            "https://drive.google.com/uc?export=view&id=1W6ekKgsb_wNP3Dp6UN3a-I7i-Ik1KFB1",
            "https://drive.google.com/uc?export=view&id=1TXjBAHHla9C5t9VTqJ5TGWaq6PVeWlRF",
            "https://drive.google.com/uc?export=view&id=1om3IKWksGrv0Y4uj7Q7ieFM7yghHBq2I"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=16mMzB0v1_iaH0VdiJ214ArEXUye0uN4B",
            "https://drive.google.com/uc?export=view&id=169Ewjju2rI7SW_l88I9gjlay4E-sPua1"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "species": "22",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-20T04:01:13.296Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-10-22T14:34:25.001Z"
        }
    },
    {
        "_id": {
            "$oid": "6350c8b61846e49d08a6a05a"
        },
        "name": "3",
        "category": "Sushi Tí",
        "subCategory": "Salad",
        "slug": "3",
        "rate": 5,
        "price": 3,
        "quantity": 10,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ZU-4ubNI0C51Lq5dR7MRPFfvJpfR6rqX",
            "https://drive.google.com/uc?export=view&id=16JwdzGOdPEeFn0Jx-k51MvKrTV5LiM1m",
            "https://drive.google.com/uc?export=view&id=1oXyXx4ItjeQNOeg-pfNGdhS0wZnANwFm",
            "https://drive.google.com/uc?export=view&id=1A02iBJi2SR1iT2xUVm3Zs5yh_R9Mxfk1"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1fouontw4_Kn1ua0ntMVqd94CIkTUOJTz",
            "https://drive.google.com/uc?export=view&id=1H87F6y-c2K0_X0-oJAqGgILbfn1CG85B"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "species": "3",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-20T04:04:06.536Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-10-22T14:33:32.743Z"
        }
    },
    {
        "_id": {
            "$oid": "6354051284b3cb0ae331baa3"
        },
        "name": "Merek",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "merek",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "Tăng Buff, Trị liệu",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1KU90eFy6w7Lv6Ph6s1WuptA9uqw4JEjG",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1KU90eFy6w7Lv6Ph6s1WuptA9uqw4JEjG",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "1",
        "skill1": "Phước Thánh",
        "skill2": "Sức Mạnh Thần Thánh",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T14:58:26.115Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Merek/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:28:36.638Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Merek/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635405cb84b3cb0ae331baa7"
        },
        "name": "Ulric",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ulric",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "Tăng Buff, Khống Chế",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1HER6a5t2Z8wOk-Y8UqGdBkI82VVO2vy1",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1HER6a5t2Z8wOk-Y8UqGdBkI82VVO2vy1",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Strength",
        "grade": "1",
        "skill1": "Đẩy Lùi",
        "skill2": "Phòng Ngự",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:01:31.491Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ulric/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-10-25T13:37:59.026Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ulric/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6354061f84b3cb0ae331baaa"
        },
        "name": "Bloodsnarl",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "bloodsnarl",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "AOE, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1riXT-IEIvqmSCvaYK6MT_bPdpJ5hHyRV",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1riXT-IEIvqmSCvaYK6MT_bPdpJ5hHyRV",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "xathu",
        "type": "Strength",
        "grade": "1",
        "skill1": "Lốc xoáy điên cuồng",
        "skill2": "Ném ngọn thương",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:02:55.593Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Bloodsnarl/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:53:25.713Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Bloodsnarl/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635406c184b3cb0ae331baae"
        },
        "name": "Arkadios",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "arkadios",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "Giảm buff, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hdL82uWdMZXzyGsgGixcUIaO5HGszvNB",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hdL82uWdMZXzyGsgGixcUIaO5HGszvNB",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "1",
        "skill1": "Mây mù",
        "skill2": "Thợ săn giận dữ",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:05:37.434Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Arkadios/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:56:34.614Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Arkadios/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635406ee84b3cb0ae331bab1"
        },
        "name": "Dreaf",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "dreaf",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "Giảm buff, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1K0p3hyDbS6hBssCO1z8TxY7mnBkMnmrw",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1K0p3hyDbS6hBssCO1z8TxY7mnBkMnmrw",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "1",
        "skill1": "Hạt độc",
        "skill2": "Gai xuyên thấu",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:06:22.056Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Dreaf/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:57:41.563Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Dreaf/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6354072084b3cb0ae331bab4"
        },
        "name": "Eletha",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "eletha",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "AOE, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1N5tyy_FGhjxk9dpD9n2_0lj8N8wsf7gV",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1N5tyy_FGhjxk9dpD9n2_0lj8N8wsf7gV",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "1",
        "skill1": "Đoàn xuyến thấu",
        "skill2": "Cường huyết",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:07:12.818Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Eletha/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:58:04.067Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Eletha/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635407b984b3cb0ae331bab9"
        },
        "name": "Steixius",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "steixius",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "Giảm buff, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=12oN8YcsL8h3uVOgj72M8P6fS0wL7M44A",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=12oN8YcsL8h3uVOgj72M8P6fS0wL7M44A",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "1",
        "skill1": "Phá dối",
        "skill2": "Mùi hôi khó chịu",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:09:45.688Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Steixius/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:17:18.668Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Steixius/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635407eb84b3cb0ae331babc"
        },
        "name": "Sezis",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "sezis",
        "rate": 1,
        "price": 1,
        "quantity": 1,
        "description": "Khống chế, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1e2F7nIFq_YWxWVZpvjs9mMGyrOK6McCi",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1e2F7nIFq_YWxWVZpvjs9mMGyrOK6McCi",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "1",
        "skill1": "Đánh mạnh",
        "skill2": "Lắc mạnh",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:10:35.287Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Sezis/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:20:17.97Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Sezis/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635408fe84b3cb0ae331bacd"
        },
        "name": "Hogan",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "hogan",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Khống chế, Đỡ đòn",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1MrREuOOy2rI_N0ZHUnW4iEMS7hJaUOv7",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1MrREuOOy2rI_N0ZHUnW4iEMS7hJaUOv7",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "2",
        "skill1": "Hiệp sĩ cuồng nộ",
        "skill2": "Đánh mạnh",
        "skill3": "Kiên nghị",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:15:10.18Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Hogan/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:58:29.136Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Hogan/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6354093184b3cb0ae331bad0"
        },
        "name": "Angelo",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "angelo",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Tăng buff, trị liệu",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1efArlGktBSkvnuqkTxpn9ySLbLkheTMK",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1efArlGktBSkvnuqkTxpn9ySLbLkheTMK",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "2",
        "skill1": "Tình yêu và hòa bình",
        "skill2": "Khích lệ",
        "skill3": "Phục hồi",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:16:01.684Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Angelo/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:58:56.215Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Angelo/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6354096e84b3cb0ae331bad3"
        },
        "name": "Morvus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "morvus",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Giảm buff, Sát thủ",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1a8PKslQ96uOvGnujtKY19_Uf6xBkMmFR",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1a8PKslQ96uOvGnujtKY19_Uf6xBkMmFR",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Agility",
        "grade": "2",
        "skill1": "Thiện xạ",
        "skill2": "Lựu đạn choáng",
        "skill3": "Trọng tâm trí mạng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:17:02.041Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Morvus/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:27:56.306Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Morvus/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635409d484b3cb0ae331bad7"
        },
        "name": "Mirael",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "mirael",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "AOE, Sát thương bạo phát",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ZGjDgu_xx7ziTamKKLmwaKU9_W4UE5_S",
            "https://drive.google.com/uc?export=view&id=1OBpnpPiNlO9qYfkjOEyX15qbLG980-vD",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ZGjDgu_xx7ziTamKKLmwaKU9_W4UE5_S",
            "https://drive.google.com/uc?export=view&id=1OBpnpPiNlO9qYfkjOEyX15qbLG980-vD"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "2",
        "skill1": "Phượng hoàng lửa",
        "skill2": "Cầu lửa",
        "skill3": "Khiên lửa",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:18:44.945Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Mirael/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:30:24.99Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Mirael/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540a0384b3cb0ae331bada"
        },
        "name": "Ankhira",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ankhira",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Giảm buff, khống chế",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=13PczYssnkzyoU0xggJnq_qGAQDFziLiV",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=13PczYssnkzyoU0xggJnq_qGAQDFziLiV",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "2",
        "skill1": "Mật độc",
        "skill2": "Ăn đòn",
        "skill3": "Cái kén",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:19:31.636Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ankhira/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T13:59:20.505Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ankhira/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540a4984b3cb0ae331bade"
        },
        "name": "Golus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "golus",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Khống chế, Đỡ đòn",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=13qy-jfvRXi54idcayi2a7PPt6JqJ5f4W",
            "https://drive.google.com/uc?export=view&id=1pgpZ9ljs54j4WFhT74T2qVcsDeFUPljF",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=13qy-jfvRXi54idcayi2a7PPt6JqJ5f4W",
            "https://drive.google.com/uc?export=view&id=1pgpZ9ljs54j4WFhT74T2qVcsDeFUPljF"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "dodon",
        "type": "Strength",
        "grade": "2",
        "skill1": "Đụng độ",
        "skill2": "Bùng nổ",
        "skill3": "Ý chí kiên cường",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:20:41.587Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Golus/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:00:06.148Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Golus/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540a9184b3cb0ae331bae1"
        },
        "name": "Saveas",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "saveas",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Sát thương bạo phát, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1YdKaA4WDtWxGm-LOi2mk-LSt8gn6245d",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1YdKaA4WDtWxGm-LOi2mk-LSt8gn6245d",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "xathu",
        "type": "Agility",
        "grade": "2",
        "skill1": "Nóng rát",
        "skill2": "Huyết giáo",
        "skill3": "Hy sinh sức mạnh",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:21:53.643Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Saveas/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:19:09.661Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Saveas/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540b0184b3cb0ae331bae4"
        },
        "name": "Ira",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ira",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Giảm buff, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=10lUv-Weq_32KaoYieB6bAHYfsSAFh_d0",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=10lUv-Weq_32KaoYieB6bAHYfsSAFh_d0",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "2",
        "skill1": "Mưa tên",
        "skill2": "Mũi tên băng",
        "skill3": "Mũi tên xuyên thấu",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:23:45.299Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ira/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-04T07:30:39.045Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ira/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540b2b84b3cb0ae331bae7"
        },
        "name": "Ogi",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ogi",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Khống chế, Đỡ đòn",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1eSHS8WpxC8LQxXShMCIoGnLGixddqInH",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1eSHS8WpxC8LQxXShMCIoGnLGixddqInH",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "dodon",
        "type": "Strength",
        "grade": "2",
        "skill1": "Kiên cường",
        "skill2": "Nứt đất",
        "skill3": "Thả bom",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:24:27.151Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ogi/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:27:13.462Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ogi/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540b5884b3cb0ae331baea"
        },
        "name": "Arden",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "arden",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Sát thương bạo, Khống chế",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1p0KoHkeNCyF1ZSab4eGkDMSRkK6xvVLT",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1p0KoHkeNCyF1ZSab4eGkDMSRkK6xvVLT",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "2",
        "skill1": "Lực lương thiên nhiên",
        "skill2": "Rễ cây trói chân",
        "skill3": "Khiên gai",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:25:12.202Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Arden/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:00:56.619Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Arden/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540b8784b3cb0ae331baed"
        },
        "name": "Niru",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "niru",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Đỡ đòn, Duy trì sát thương",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ni5-cCYm7Nc0qBYRu4S62D-99rmH7XEm",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ni5-cCYm7Nc0qBYRu4S62D-99rmH7XEm",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Intelligence",
        "grade": "2",
        "skill1": "Tiếng gọi tử thần",
        "skill2": "Hút máu",
        "skill3": "Thần chết",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:25:59.356Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Niru/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:26:09.978Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Niru/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540bb684b3cb0ae331baf0"
        },
        "name": "Silvina",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "silvina",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "Sát thương bạo, Sát thủ",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1HDMMJg975hb_tROv-dbJLeJ3Sikx3MbX",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1HDMMJg975hb_tROv-dbJLeJ3Sikx3MbX",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "xathu",
        "type": "Agility",
        "grade": "2",
        "skill1": "Đòn chí mạng",
        "skill2": "Khiên vực thẳm",
        "skill3": "Máu đầu tiên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:26:46.595Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Silvina/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:16:24.434Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Silvina/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540bdb84b3cb0ae331baf3"
        },
        "name": "Vedan",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "vedan",
        "rate": 2,
        "price": 2,
        "quantity": 1,
        "description": "AOE, Đỡ đòn",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1gY371yxtfhSKEa1Gn9JFM3m4_66AwJbr",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1gY371yxtfhSKEa1Gn9JFM3m4_66AwJbr",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Agility",
        "grade": "2",
        "skill1": "Dơi đen",
        "skill2": "Sức mạnh",
        "skill3": "Khát máu",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:27:23.984Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Vedan/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-10-25T13:52:46.304Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Vedan/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540cfe84b3cb0ae331baf8"
        },
        "name": "Estrilda",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "estrilda",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Sát thương bạo kích",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1dOMOf0bTi_q2UBy3kFWDmBbeQPHSdryJ",
            "https://drive.google.com/uc?export=view&id=1-9R7whuQai91ccVspsOQcSU_IZIys7Qa",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1dOMOf0bTi_q2UBy3kFWDmBbeQPHSdryJ",
            "https://drive.google.com/uc?export=view&id=1-9R7whuQai91ccVspsOQcSU_IZIys7Qa"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:32:14.418Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Estrilda/1.png",
        "image2": "/assets/images/heroes/afkarena/Estrilda/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:01:42.416Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Estrilda/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Estrilda/2.jpg"
    },
    {
        "_id": {
            "$oid": "63540d1b84b3cb0ae331bafb"
        },
        "name": "Belinda",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "belinda",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "AOE",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1R3o6yHdBwVXnXmW3ynkQCSYYZgziAXOt",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1R3o6yHdBwVXnXmW3ynkQCSYYZgziAXOt",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:32:43.841Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Belinda/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:02:02.847Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Belinda/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540d3184b3cb0ae331bafe"
        },
        "name": "Raine",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "raine",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ZgynqqyH_DjF06RRNxKDgRu6FZiUH_Ks",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ZgynqqyH_DjF06RRNxKDgRu6FZiUH_Ks",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:33:05.947Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Raine/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:23:55.051Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Raine/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540d4084b3cb0ae331bb01"
        },
        "name": "Fawkes",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "fawkes",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ynL8XiQUnb2mczqAQP4vCjk0O_iNkb2R",
            "https://drive.google.com/uc?export=view&id=1kC559JCGwWpETDQ9vmUm_MKGWznSxdpC",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ynL8XiQUnb2mczqAQP4vCjk0O_iNkb2R",
            "https://drive.google.com/uc?export=view&id=1kC559JCGwWpETDQ9vmUm_MKGWznSxdpC"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:33:20.964Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Fawkes/1.png",
        "image2": "/assets/images/heroes/afkarena/Fawkes/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:02:55.412Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Fawkes/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Fawkes/2.jpg"
    },
    {
        "_id": {
            "$oid": "63540d5b84b3cb0ae331bb05"
        },
        "name": "Thane",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "thane",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1QfjJavG7abGZ1zBhVaInKKfcVvj_QGJ9",
            "https://drive.google.com/uc?export=view&id=1sNR7eLSnKCrP8fMnSHIGF1ZU0dzB2GOX",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1QfjJavG7abGZ1zBhVaInKKfcVvj_QGJ9",
            "https://drive.google.com/uc?export=view&id=1sNR7eLSnKCrP8fMnSHIGF1ZU0dzB2GOX"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:33:47.979Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Thane/1.png",
        "image2": "/assets/images/heroes/afkarena/Thane/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:10:05.434Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Thane/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Thane/2.jpg"
    },
    {
        "_id": {
            "$oid": "63540d6984b3cb0ae331bb08"
        },
        "name": "Hendrik",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "hendrik",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Zb1TWeH5YOcKRpdeucmftN0YU2u_4Ww3",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Zb1TWeH5YOcKRpdeucmftN0YU2u_4Ww3",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:34:01.122Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Hendrik/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:03:19.558Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Hendrik/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540d7584b3cb0ae331bb0b"
        },
        "name": "Rowan",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "rowan",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Tf7wRwFIKKumCqywmturH40Udcd-JzS7",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Tf7wRwFIKKumCqywmturH40Udcd-JzS7",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:34:13.341Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Rowan/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:20:01.433Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Rowan/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540d8584b3cb0ae331bb0e"
        },
        "name": "Gwyneth",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "gwyneth",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1X3nOduRcxvEycg4gpkTlx3oRie8IRpTV",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1X3nOduRcxvEycg4gpkTlx3oRie8IRpTV",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:34:29.467Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Gwyneth/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:03:45.124Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Gwyneth/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540d9184b3cb0ae331bb11"
        },
        "name": "Rosaline",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "rosaline",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Z8qgjkzpxyHsehdg6weV8vIOGcCtcZSf",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Z8qgjkzpxyHsehdg6weV8vIOGcCtcZSf",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:34:41.195Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Rosaline/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:22:05.655Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Rosaline/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540d9d84b3cb0ae331bb14"
        },
        "name": "Cecilia",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "cecilia",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Lee8gjifTCLCljhCYGtKrxMWc1UqaT3l",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Lee8gjifTCLCljhCYGtKrxMWc1UqaT3l",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:34:53.177Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Cecilia/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:04:12.806Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Cecilia/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540daa84b3cb0ae331bb17"
        },
        "name": "Rigby",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "rigby",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1PdBt6rHfklX17SN0rbxV47CxRPFhxy3Y",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1PdBt6rHfklX17SN0rbxV47CxRPFhxy3Y",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:35:06.133Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Rigby/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:21:51.734Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Rigby/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540db584b3cb0ae331bb1a"
        },
        "name": "Oscar",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "oscar",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1kSreYhqrlPBMqZcYgaLRM-RWFpNOI4QP",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1kSreYhqrlPBMqZcYgaLRM-RWFpNOI4QP",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:35:17.064Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Oscar/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:21:37.866Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Oscar/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540dc284b3cb0ae331bb1d"
        },
        "name": "Eluard",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "eluard",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1D8OZQMGMM7Cj9TCOXACKjS_ESb4TG8-a",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1D8OZQMGMM7Cj9TCOXACKjS_ESb4TG8-a",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:35:30.773Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Eluard/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:04:46.8Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Eluard/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540dcb84b3cb0ae331bb20"
        },
        "name": "Peggy",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "peggy",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1UZuqF06TkXU90tJizzgO6XbnIRojHha6",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1UZuqF06TkXU90tJizzgO6XbnIRojHha6",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:35:39.755Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Peggy/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:24:09.717Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Peggy/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540dd584b3cb0ae331bb23"
        },
        "name": "Walker",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "walker",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1RtgdjMvOSeqsGT5uz4z9RZNEp0HlGWDo",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1RtgdjMvOSeqsGT5uz4z9RZNEp0HlGWDo",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:35:49.378Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Walker/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-10-25T14:11:01.184Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Walker/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540de284b3cb0ae331bb26"
        },
        "name": "Morrow",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "morrow",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1JXmdoZScpUuuhwvs1MStPftRlnrMyogn",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1JXmdoZScpUuuhwvs1MStPftRlnrMyogn",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:36:02.458Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Morrow/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:29:20.158Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Morrow/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540dea84b3cb0ae331bb29"
        },
        "name": "Scarlet",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "scarlet",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1uX5EsmMyrAD05q5_tj1K48HC31ah6Jax",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1uX5EsmMyrAD05q5_tj1K48HC31ah6Jax",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:36:10.403Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Scarlet/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:18:29.002Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Scarlet/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e2484b3cb0ae331bb2d"
        },
        "name": "Thane*",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "thane*",
        "rate": 4,
        "price": 4,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1FfFoFHqhITh1MoN5cxMpTegE53E1nOYt",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1FfFoFHqhITh1MoN5cxMpTegE53E1nOYt",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "xathu",
        "type": "Agility",
        "grade": "4",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:37:08.862Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/ThaneSP/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:09:13.971Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/ThaneSP/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e3984b3cb0ae331bb30"
        },
        "name": "Sonja",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "sonja",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1mNxYGAjtqp3X_I97xdfw6UPbTBZ-kh_z",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1mNxYGAjtqp3X_I97xdfw6UPbTBZ-kh_z",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoimanganhsang",
        "species": "dodon",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:37:29.261Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Sonja/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:14:25.93Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Sonja/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e4984b3cb0ae331bb33"
        },
        "name": "Brutus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "brutus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1rkvFqUv5cAJd2gwp1oTw_EkeDyNWppgJ",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1rkvFqUv5cAJd2gwp1oTw_EkeDyNWppgJ",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:37:45.825Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Brutus/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:05:13.104Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Brutus/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e5784b3cb0ae331bb36"
        },
        "name": "Khasos",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "khasos",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=12FTIek71q8FT694jayjuQD_btFLmuJ1x",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=12FTIek71q8FT694jayjuQD_btFLmuJ1x",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:37:59.215Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Khasos/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:37:24.509Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Khasos/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e6584b3cb0ae331bb39"
        },
        "name": "Vurk",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "vurk",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ZbD9OacB6ajzpIwQP2p0uPT6VXxW0yjD",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ZbD9OacB6ajzpIwQP2p0uPT6VXxW0yjD",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:38:13.61Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Vurk/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T04:44:35.932Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Vurk/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e7184b3cb0ae331bb3c"
        },
        "name": "Numisu",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "numisu",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1PUcoQQFuCJbjqRFt_U2KX82AmwewBgen",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1PUcoQQFuCJbjqRFt_U2KX82AmwewBgen",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:38:25.001Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Numisu/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:26:59.264Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Numisu/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e7c84b3cb0ae331bb3f"
        },
        "name": "Skreg",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "skreg",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hM4ZoaHrltljg7JyJW12qxmKgPDrkJTq",
            "https://drive.google.com/uc?export=view&id=1KVyI4M9wJF-LamWzTkFcA-dAQfsTa87q",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hM4ZoaHrltljg7JyJW12qxmKgPDrkJTq",
            "https://drive.google.com/uc?export=view&id=1KVyI4M9wJF-LamWzTkFcA-dAQfsTa87q"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:38:36.305Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Skreg/1.png",
        "image2": "/assets/images/heroes/afkarena/Skreg/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:15:42.793Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Skreg/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Skreg/2.jpg"
    },
    {
        "_id": {
            "$oid": "63540e8584b3cb0ae331bb42"
        },
        "name": "Warek",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "warek",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ttVFJkL70k0YAwxfqXsNuOzJfFThvsWo",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ttVFJkL70k0YAwxfqXsNuOzJfFThvsWo",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:38:45.966Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Warek/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T04:47:56.42Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Warek/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e9284b3cb0ae331bb45"
        },
        "name": "Antandra",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "antandra",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1eWHorINcjR-R_qGxMQpbhEfazgk23pT5",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1eWHorINcjR-R_qGxMQpbhEfazgk23pT5",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:38:58.787Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Antandra/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:05:55.367Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Antandra/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540e9f84b3cb0ae331bb48"
        },
        "name": "Safiya",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "safiya",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=19vE_k7-8MT1oiYzlIuF-p3u60TO5uD-u",
            "https://drive.google.com/uc?export=view&id=1RSyNqEGUU_B1OswParGvp-MNLKL1etrm",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=19vE_k7-8MT1oiYzlIuF-p3u60TO5uD-u",
            "https://drive.google.com/uc?export=view&id=1RSyNqEGUU_B1OswParGvp-MNLKL1etrm"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:39:11.809Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Safiya/1.png",
        "image2": "/assets/images/heroes/afkarena/Safiya/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:21:14.133Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Safiya/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Safiya/2.jpg"
    },
    {
        "_id": {
            "$oid": "63540ea884b3cb0ae331bb4b"
        },
        "name": "Satrana",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "satrana",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Sw1uxyeCzkgi5jUQh9iUVG7tqLI9q_JH",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Sw1uxyeCzkgi5jUQh9iUVG7tqLI9q_JH",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:39:20.196Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Satrana/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:19:43.784Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Satrana/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540eb284b3cb0ae331bb4e"
        },
        "name": "Tidus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "tidus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1tTUm8g3wiw27YRiRh4MpruvKo4T3P5XX",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1tTUm8g3wiw27YRiRh4MpruvKo4T3P5XX",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:39:30.559Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Tidus/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:13:26.563Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Tidus/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540eba84b3cb0ae331bb51"
        },
        "name": "Drez",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "drez",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ri5tZb9Vn4cxRW47chDTEm4RVcfx8j8A",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ri5tZb9Vn4cxRW47chDTEm4RVcfx8j8A",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:39:38.947Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Drez/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:06:17.971Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Drez/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540ec584b3cb0ae331bb54"
        },
        "name": "Skriath",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "skriath",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Z5ACVIBHoxpPNGhl2qbVMUXZvGqwtM4P",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Z5ACVIBHoxpPNGhl2qbVMUXZvGqwtM4P",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:39:49.362Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Skriath/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:14:03.52Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Skriath/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540ecf84b3cb0ae331bb57"
        },
        "name": "Anoki",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "anoki",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1AvYwoLxooLubVDuv1AcsYcoPmLfnajL9",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1AvYwoLxooLubVDuv1AcsYcoPmLfnajL9",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:39:59.341Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Anoki/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:06:35.064Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Anoki/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540edb84b3cb0ae331bb5a"
        },
        "name": "Kren",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "kren",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Kyi4TVeM9r4R5-a_Kr7lDopeGJTXzd1D",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Kyi4TVeM9r4R5-a_Kr7lDopeGJTXzd1D",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:40:11.842Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Kren/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:35:23.627Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Kren/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540ee784b3cb0ae331bb5d"
        },
        "name": "Thali",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "thali",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1xMh9dqcMVtzo3lRcCBfiJlkW9t1cmCaM",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1xMh9dqcMVtzo3lRcCBfiJlkW9t1cmCaM",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:40:23.133Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Thali/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:12:20.743Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Thali/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540ef384b3cb0ae331bb60"
        },
        "name": "Granit",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "granit",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1jlHjc3t90wnphnt5tP1IOflQh5sBPj_n",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1jlHjc3t90wnphnt5tP1IOflQh5sBPj_n",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:40:35.534Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Granit/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:06:58.461Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Granit/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540efc84b3cb0ae331bb63"
        },
        "name": "Thesku",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "thesku",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1CseJMxJAy0wX0el6cBOx6_-fCa19RGTD",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1CseJMxJAy0wX0el6cBOx6_-fCa19RGTD",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:40:44.689Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Thesku/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:12:42.151Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Thesku/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540f0684b3cb0ae331bb66"
        },
        "name": "Alaro",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "alaro",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ncOmgJKmC0t_iSx-lOCOqMUsirNun7P9",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ncOmgJKmC0t_iSx-lOCOqMUsirNun7P9",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "hotro",
        "type": "Agility",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:40:54.522Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Alaro/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:07:17.407Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Alaro/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540f1684b3cb0ae331bb69"
        },
        "name": "Anasta",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "anasta",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1h30weum1q6Ivn_WF3-9WL1gbcVPDlld4",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1h30weum1q6Ivn_WF3-9WL1gbcVPDlld4",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:41:10.148Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Anasta/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:07:33.707Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Anasta/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540f2884b3cb0ae331bb6d"
        },
        "name": "Brutus*",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "brutus*",
        "rate": 4,
        "price": 4,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1rtOk2QP9koXfux_IYD1A-cDCdwhgct7v",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1rtOk2QP9koXfux_IYD1A-cDCdwhgct7v",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoithu",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "4",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:41:28.748Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/BrutusSP/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:07:57.401Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/BrutusSP/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63540f3f84b3cb0ae331bb70"
        },
        "name": "Nemora",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "nemora",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1RWXaTXZfmH43-LeYyBivtlyjKlaGKxog",
            "https://drive.google.com/uc?export=view&id=1Ifsw5GLCOawDTzpQb-vyzXfUpRb65NBm",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1RWXaTXZfmH43-LeYyBivtlyjKlaGKxog",
            "https://drive.google.com/uc?export=view&id=1Ifsw5GLCOawDTzpQb-vyzXfUpRb65NBm"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "",
        "skill2": "",
        "skill3": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-22T15:41:51.8Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Nemora/1.png",
        "image2": "/assets/images/heroes/afkarena/Nemora/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:25:49.935Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Nemora/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Nemora/2.jpg"
    },
    {
        "_id": {
            "$oid": "635737039b414ebbab1ae45b"
        },
        "name": "Saurus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "saurus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Saurus is a melee DPS with high boss damage.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1gFupIe-kcZcwpiXMm9uvd0WrVrE0mcjI",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1gFupIe-kcZcwpiXMm9uvd0WrVrE0mcjI",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "Phase Form",
        "skill2": "War Strike",
        "skill3": "Burst Strikes",
        "skill4": "Tenacity",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:08:19.092Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Saurus/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:19:27.043Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Saurus/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635737439b414ebbab1ae45e"
        },
        "name": "Solise",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "solise",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Solise is a mage that can summon flowers to aid her in battle.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1gcUvBCTAOdsQLDIAw3m3NlJWiORyF4T3",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1gcUvBCTAOdsQLDIAw3m3NlJWiORyF4T3",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "Blossom Fall",
        "skill2": "Floral Disruption",
        "skill3": "Floral Specter",
        "skill4": "Forest's Blessing",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:09:23.096Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Solise/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:14:46.057Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Solise/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635737929b414ebbab1ae461"
        },
        "name": "Lorsan",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "lorsan",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Lorsan can deal AoE damage, increase enemy damage taken and shield allies.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Y7dX5R_oKPS6TP5JpGd0MuURRi0417cg",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Y7dX5R_oKPS6TP5JpGd0MuURRi0417cg",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "Tempest",
        "skill2": "Inner Sight",
        "skill3": "Gale Force",
        "skill4": "Wind Ward",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:10:42.348Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Lorsan/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:37:56.555Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Lorsan/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635737d29b414ebbab1ae464"
        },
        "name": "Gorvo",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "gorvo",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Gorvo is a tank capable of stunning enemies and shielding himself.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1EeFuvUw2YJwlX7OrWAun_uNDgleozprM",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1EeFuvUw2YJwlX7OrWAun_uNDgleozprM",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "Battle Cry",
        "skill2": "Dive Bomb",
        "skill3": "Shell Shock",
        "skill4": "Hellspawn",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:11:46.854Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Gorvo/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:08:27.629Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Gorvo/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6357383c9b414ebbab1ae467"
        },
        "name": "Eironn",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "eironn",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Eironn is a melee DPS that can pull enemies towards him, summon tornadoes and deal increased damage to shielded enemies.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1h-xhFudNaEKkmmmNFcIcoV5kNLluMVNT",
            "https://drive.google.com/uc?export=view&id=14xGf2sQeWCdhKgc6edT9lDtEG9kdm0_F",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1h-xhFudNaEKkmmmNFcIcoV5kNLluMVNT",
            "https://drive.google.com/uc?export=view&id=14xGf2sQeWCdhKgc6edT9lDtEG9kdm0_F"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "Elemental Surge",
        "skill2": "Twin Force",
        "skill3": "Vortex",
        "skill4": "Sylvan Oath",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:13:32.471Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Eironn/1.png",
        "image2": "/assets/images/heroes/afkarena/Eironn/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:09:03.827Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Eironn/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Eironn/2.jpg"
    },
    {
        "_id": {
            "$oid": "635738729b414ebbab1ae46a"
        },
        "name": "Kaz",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "kaz",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Kaz is hero that relies heavily on dodging enemy attacks. She can act as a tank and excels in long battles.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1JWMVCQsjlJS_6NBL3e5ik8o5KrKZ9HFA",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1JWMVCQsjlJS_6NBL3e5ik8o5KrKZ9HFA",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "Assassinate",
        "skill2": "Triple Strike",
        "skill3": "Evasive Strike",
        "skill4": "Feline Finesse",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:14:26.349Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Kaz/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:09:24.202Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Kaz/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635738b59b414ebbab1ae46d"
        },
        "name": "Lyca",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "lyca",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Lyca is a support that can provide her team with a strong opener. She can buff allies and give them energy.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1xNBhZoNunqlFhwrLn6O0Q9LR1fSyc9VP",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1xNBhZoNunqlFhwrLn6O0Q9LR1fSyc9VP",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "skill1": "Arrow of Justice",
        "skill2": "Foe's Fragility",
        "skill3": "Awe",
        "skill4": "Rapid Arrows",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:15:33.764Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Lyca/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:36:24.75Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Lyca/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635738fc9b414ebbab1ae470"
        },
        "name": "Seirus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "seirus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Seirus is a control oriented tank that can CC enemies and deal AoE damage.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1jAKBq5e4yheFvkv96G9pDuys9j3ky_Ki",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1jAKBq5e4yheFvkv96G9pDuys9j3ky_Ki",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "skill1": "Abhorrent Torrent",
        "skill2": "Deluge",
        "skill3": "Ocean's Blessing",
        "skill4": "Free Flow",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:16:44.212Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Seirus/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:18:13.874Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Seirus/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "635739379b414ebbab1ae473"
        },
        "name": "Tasi",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "tasi",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Tasi is a support hero with powerful CC that teleport away from enemies. Her ult can lockdown an entire team, and she can also banish the strongest enemy at the start of the game.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1cxuc63jMFuLlphZj40llCLuN2IFDoSTO",
            "https://drive.google.com/uc?export=view&id=1oVkDPbscmSPKFKYAT7EPqGa6AP0aWvq6",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1cxuc63jMFuLlphZj40llCLuN2IFDoSTO",
            "https://drive.google.com/uc?export=view&id=1oVkDPbscmSPKFKYAT7EPqGa6AP0aWvq6"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "skill1": "Slumber",
        "skill2": "Dream Spirit",
        "skill3": "Banishment",
        "skill4": "Teleportation",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:17:43.347Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Tasi/1.png",
        "image2": "/assets/images/heroes/afkarena/Tasi/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:11:31.47Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Tasi/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Tasi/2.jpg"
    },
    {
        "_id": {
            "$oid": "6357397f9b414ebbab1ae476"
        },
        "name": "Ulmus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ulmus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Ulmus is a tank that can heal himself and allies.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ptYGPb2pBOd1geyxAx2Oq4HWVpvNUqu7",
            "https://drive.google.com/uc?export=view&id=1qb3nGoOH4esmreEm-Qd9ZX0qyljXj36n",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ptYGPb2pBOd1geyxAx2Oq4HWVpvNUqu7",
            "https://drive.google.com/uc?export=view&id=1qb3nGoOH4esmreEm-Qd9ZX0qyljXj36n",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "Deep Roots",
        "skill2": "Writhing Roots",
        "skill3": "Forest's Oath",
        "skill4": "Life Torrent",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:18:55.727Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ulmus/1.png",
        "image2": "/assets/images/heroes/afkarena/Ulmus/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-10-25T14:29:28.077Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ulmus/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Ulmus/2.png"
    },
    {
        "_id": {
            "$oid": "63573b219b414ebbab1ae47e"
        },
        "name": "Arthur",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "arthur",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "Arthur is a tank that can buff allies behind him.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1io1WnkufeAbB_CHKV4mrHOvEeCvg8DSX",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1io1WnkufeAbB_CHKV4mrHOvEeCvg8DSX",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "skill1": "Smite",
        "skill2": "Excalibur's Fury",
        "skill3": "King's Blessing",
        "skill4": "Shield of Honor",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:25:53.519Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Arthur/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:10:16.259Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Arthur/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573b609b414ebbab1ae481"
        },
        "name": "Ukyo",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ukyo",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Ukyo is a melee DPS that can teleport to enemies.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1cXa0EHyE4I1j0tbtvQjorFo3ct7SbIJc",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1cXa0EHyE4I1j0tbtvQjorFo3ct7SbIJc",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "5",
        "skill1": "Hientorajin",
        "skill2": "Snowfall Slash",
        "skill3": "Phantom Strike",
        "skill4": "Swallow Swipe",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:26:56.969Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ukyo/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-10-25T14:30:07.318Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ukyo/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573be29b414ebbab1ae487"
        },
        "name": "Nakoruru",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "nakoruru",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Nakoruru is a melee DPS that can interrupt enemies.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1WGciR0T8ogHQPi85p2Fhc5zL1P8mTUHd",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1WGciR0T8ogHQPi85p2Fhc5zL1P8mTUHd",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "xathu",
        "type": "Agility",
        "grade": "5",
        "skill1": "Shichikapu Amu",
        "skill2": "Running Chest Jab",
        "skill3": "Shichikapu Amu",
        "skill4": "Kamui Mutsube",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:29:06.84Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Nakoruru/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:26:45.052Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Nakoruru/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573c089b414ebbab1ae48a"
        },
        "name": "Ezio",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ezio",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Ezio is a melee assassin that can debuff enemies and avoid their attacks.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1NZyAaD_YJeRTfy_P6IaWud5lnZdcvyj2",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1NZyAaD_YJeRTfy_P6IaWud5lnZdcvyj2",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "xathu",
        "type": "Agility",
        "grade": "5",
        "skill1": " Eagle Vision",
        "skill2": "Final Retribution",
        "skill3": "Smoke Bomb",
        "skill4": "Evasion",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:29:44.444Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ezio/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:11:04.388Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ezio/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573c3a9b414ebbab1ae48d"
        },
        "name": "Ainz Ooal Gown",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ainz-ooal-gown",
        "rate": 5,
        "price": 5,
        "quantity": 1,
        "description": "Ainz Ooal Gown is a mage caster with high AoE burst damage.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1wxKUfNFJ68PbDqKz0vmntrSZspEfjPTa",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/2.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1wxKUfNFJ68PbDqKz0vmntrSZspEfjPTa",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "5",
        "skill1": "Fallen Down",
        "skill2": "Magic Caster",
        "skill3": "The Goal of All Life Is Death",
        "skill4": "Steady Preparations",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:30:34.749Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "https://drive.google.com/uc?export=view&id=1wxKUfNFJ68PbDqKz0vmntrSZspEfjPTa",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/2.png",
        "image4": "/assets/images/products/clothes/2.png",
        "modified": {
            "$date": "2022-11-03T02:01:44.376Z"
        },
        "thumbImage1": "https://drive.google.com/uc?export=view&id=1wxKUfNFJ68PbDqKz0vmntrSZspEfjPTa",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573c8c9b414ebbab1ae490"
        },
        "name": "Albedo",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "albedo",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Albedo is a tank that can shield allies and deal AoE damage to enemies.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1l2Xljhx7Ipw1oIf5ewmWrj0WHPU9klE8",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1l2Xljhx7Ipw1oIf5ewmWrj0WHPU9klE8",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "dodon",
        "type": "Strength",
        "grade": "5",
        "skill1": "Ginnungagap",
        "skill2": " Black Guard",
        "skill3": "Shield Lord",
        "skill4": "Hermes Trismegistus",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:31:56.536Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Albedo/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:11:56.036Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Albedo/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573d2a9b414ebbab1ae493"
        },
        "name": "JOKER",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "joker",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "JOKER is an agility-based ranger hero of the Dimensional faction, coming from a crossover with Persona 5. He can choose an enemy then change his faction to gain factional advantages against them. When all enemies are controlled, he can trigger All-Out Attack to deal great AoE damage to all of them.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1uvQTXvJvuQVOIj00w1SmuGk8csGMmeK5",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1uvQTXvJvuQVOIj00w1SmuGk8csGMmeK5",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "xathu",
        "type": "Agility",
        "grade": "5",
        "skill1": "Maeigaon",
        "skill2": "Concentrated Fire ",
        "skill3": "Adverse Reaction ",
        "skill4": "All-Out Attack",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:34:34.321Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/JOKER/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:12:17.532Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/JOKER/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573d779b414ebbab1ae496"
        },
        "name": "QUEEN",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "queen",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "QUEEN is a strength-based warrior hero of the Dimensional faction, coming from a crossover with Persona 5. She can use Johanna to deals tons of damage to her enemies and landing crits.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1qBEFsK2wotYY-HxcmdjfQMNCoNuh2WLK",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1qBEFsK2wotYY-HxcmdjfQMNCoNuh2WLK",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "5",
        "skill1": "Stationary Drifter",
        "skill2": "Freidyne",
        "skill3": "Attack & Defend",
        "skill4": "Ms. Post-Apocalyptic Raider",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:35:51.56Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/QUEEN/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:23:08.893Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/QUEEN/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573daa9b414ebbab1ae499"
        },
        "name": " Prince of Persia",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "-prince-of-persia",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Prince of Persia, or, arguably, Dastan, is an agility-based ranger hero of the Dimensional faction who specializes in dealing high damage to enemy heroes. He also possesses a cheat-death ability as well as many skills boosting his survivability and mobility, making him a formidable assassin.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hlq9WBPiyGmFA98x3AvwH8QdqX7uyttw",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hlq9WBPiyGmFA98x3AvwH8QdqX7uyttw",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "xathu",
        "type": "Agility",
        "grade": "5",
        "skill1": "Sands of Time",
        "skill2": "Tempest of Agony",
        "skill3": "Wall Dive Attack",
        "skill4": "Concentrated Force",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:36:42.138Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/PrinceofPersia/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:23:39.188Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/PrinceofPersia/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573dd79b414ebbab1ae49c"
        },
        "name": "Merlin",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "merlin",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Merlin is an intelligence-based support hero of the Dimensional faction. He is able to foresee the future with premonitions, and protects allies whenever enemies use their Ultimate abilities.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1gjSlDgpJcwJM-gJHCc1jddwmJtYMNrKx",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1gjSlDgpJcwJM-gJHCc1jddwmJtYMNrKx",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "5",
        "skill1": "Destiny Foreseen",
        "skill2": "Magical Amelioration",
        "skill3": "Karmic Law",
        "skill4": "Guardian Owl",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:37:27.809Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Merlin/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:28:57.357Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Merlin/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573e369b414ebbab1ae4a0"
        },
        "name": "Leonardo",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "leonardo",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Leonardo is an intelligence-based mage hero of the Dimensional faction who uses his paintbrush and inventions to control enemies, and is able to eject himself to safety when in danger. He is based on real-life Italian artist Leonardo da Vinci.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1OI9uspBcNqj4SWh-BhzLWj9sHSSlVovP",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1OI9uspBcNqj4SWh-BhzLWj9sHSSlVovP",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "5",
        "skill1": "Work of Art ",
        "skill2": "Art Attack",
        "skill3": "Renaissance Cannon",
        "skill4": "Evacuation",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:39:02.406Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Leonardo/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:37:40.676Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Leonardo/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573e5e9b414ebbab1ae4a3"
        },
        "name": "Melusina",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "melusina",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Melusina or \"Baba Yaga\" is an intelligence-based mage of the Dimensional faction.",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1mkmmWOhulNhjcOLbTgi_WxIzZ7AlPOUD",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1mkmmWOhulNhjcOLbTgi_WxIzZ7AlPOUD",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "5",
        "skill1": "Dropping By",
        "skill2": "Treacherous Treehouse",
        "skill3": "Alchemic Witchcraft",
        "skill4": "Soul Pilfer",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:39:42.837Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Melusina/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:31:27.03Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Melusina/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "63573f339b414ebbab1ae4a9"
        },
        "name": "Grezhul",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "grezhul",
        "rate": 3,
        "price": 5,
        "quantity": 1,
        "description": "Grezhul is a strength-based tank hero of the Graveborn faction who is able to summon minions for the allied team. He gives himself or an ally a shield which can soak damage. Once the shield is destroyed, nearby enemies will receive damage. He is also known for his passive buff which reduces all incoming magic damage for all allies",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hxx1I-Czv8BGL--sJYqp5_U7W4izXcnw",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hxx1I-Czv8BGL--sJYqp5_U7W4izXcnw",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Strength",
        "grade": "5",
        "skill1": "Reanimate",
        "skill2": "Demonic Assault",
        "skill3": "Shadow Shield",
        "skill4": "Deathly Protection",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T01:43:15.972Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Grezhul/1.png",
        "image2": "/assets/images/products/clothes/2.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:13:48.584Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Grezhul/1.png",
        "thumbImage2": "/assets/images/products/clothes/2.png"
    },
    {
        "_id": {
            "$oid": "6357f64e86e3949875a0c1bb"
        },
        "name": "Joan Of Arc",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "joan-of-arc",
        "rate": 5,
        "price": 5,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1E7AmSqdDWNiulgckKpHS0ecis0gi5sy8",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1E7AmSqdDWNiulgckKpHS0ecis0gi5sy8",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "hotro",
        "type": "Strength",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:44:30.745Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:14:32.931Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f66586e3949875a0c1be"
        },
        "name": "Geralt",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "geralt",
        "rate": 5,
        "price": 5,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1dpWy-xkcWWj6Xq_mrywK7Zkkteii9iFp",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1dpWy-xkcWWj6Xq_mrywK7Zkkteii9iFp",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:44:53.389Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:15:02.613Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f67986e3949875a0c1c1"
        },
        "name": "Yennefer",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "yennefer",
        "rate": 5,
        "price": 5,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1G5KYhv4fHfz33StZ316LIvmcnqBAMFSP",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1G5KYhv4fHfz33StZ316LIvmcnqBAMFSP",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "anhhungkhongian",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:45:13.076Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6357f6d386e3949875a0c1c4"
        },
        "name": "Pippa",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "pippa",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1iVvhqV1jCyqO3wvgjBZ6b1q1eqklRMyH",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1iVvhqV1jCyqO3wvgjBZ6b1q1eqklRMyH",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:46:43.729Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:22:35.034Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f6f286e3949875a0c1c7"
        },
        "name": "Respen",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "respen",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1gyn7GnBUd2yqLwmIgQ1DbcO15QvJXLXh",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1gyn7GnBUd2yqLwmIgQ1DbcO15QvJXLXh",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:47:14.77Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:23:25.412Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f70f86e3949875a0c1ca"
        },
        "name": "Raku",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "raku",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ORnqj3hVGaVHScqnERkBMvCVDI8I7BJr",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ORnqj3hVGaVHScqnERkBMvCVDI8I7BJr",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:47:43.705Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:22:21.864Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f72986e3949875a0c1cd"
        },
        "name": "Mishka",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "mishka",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1z8N_9UTZTUOXjVb1Leb3JRRQN1qORdtr",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1z8N_9UTZTUOXjVb1Leb3JRRQN1qORdtr",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:48:09.162Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:31:09.205Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f73f86e3949875a0c1d0"
        },
        "name": "Astar",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "astar",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1zZLAu0bQ8scRTQVMxoNkpDDo4LssaV7p",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1zZLAu0bQ8scRTQVMxoNkpDDo4LssaV7p",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:48:31.377Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:15:26.644Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f74f86e3949875a0c1d3"
        },
        "name": "Oku",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "oku",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hiszJwy_FLpT7ZQ7QNCMXK-Cq7Xw2m6w",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hiszJwy_FLpT7ZQ7QNCMXK-Cq7Xw2m6w",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:48:47.906Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:26:25.78Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f76a86e3949875a0c1d6"
        },
        "name": "Eorin",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "eorin",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1GF0JVIRfL-BgNc6D1RBuwNeEF-bHtYJp",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1GF0JVIRfL-BgNc6D1RBuwNeEF-bHtYJp",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:49:14.641Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:15:47.978Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f77f86e3949875a0c1d9"
        },
        "name": "Solise*",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "solise*",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1W8DYfgdHftcy4bqWLXTR9kgbR7cdsIRb",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1W8DYfgdHftcy4bqWLXTR9kgbR7cdsIRb",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:49:35.115Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:16:07.07Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f79286e3949875a0c1dc"
        },
        "name": "Nevanthi",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "nevanthi",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Z9D0GLtBGy5LH90rOc3FzJ1v81kdO0I1",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Z9D0GLtBGy5LH90rOc3FzJ1v81kdO0I1",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoirung",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:49:54.093Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:25:04.815Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f81a86e3949875a0c1e0"
        },
        "name": "Shemira",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "shemira",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1YHWLz7Wq30_Mcau6bQ1TSmIDvoOtUG9F",
            "https://drive.google.com/uc?export=view&id=1K8AQzMShgYqeo3mvP2wiZDGEDb50p5qe",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1YHWLz7Wq30_Mcau6bQ1TSmIDvoOtUG9F",
            "https://drive.google.com/uc?export=view&id=1K8AQzMShgYqeo3mvP2wiZDGEDb50p5qe"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:52:10.202Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Shemira/1.png",
        "image2": "/assets/images/heroes/afkarena/Shemira/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:17:51.599Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Shemira/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Shemira/2.jpg"
    },
    {
        "_id": {
            "$oid": "6357f85b86e3949875a0c1e3"
        },
        "name": "Thoran",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "thoran",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=19lfqIg5e482_KYD1fglxcPWQlxrpzAFe",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=19lfqIg5e482_KYD1fglxcPWQlxrpzAFe",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:53:15.31Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:10:34.064Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f87a86e3949875a0c1e6"
        },
        "name": "Isabella",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "isabella",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1N9hDtfLCpOwHj9159JH8UZ2_a5kkMAQz",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1N9hDtfLCpOwHj9159JH8UZ2_a5kkMAQz",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:53:46.01Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:16:14.295Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f8af86e3949875a0c1e9"
        },
        "name": "Nara",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "nara",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1lf3ufeztMLhdIMSFt0_6_K5ET792Q0BQ",
            "https://drive.google.com/uc?export=view&id=1-tC1sPCTNoB3xHtA02mQGKmtE3JRkJtz",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1lf3ufeztMLhdIMSFt0_6_K5ET792Q0BQ",
            "https://drive.google.com/uc?export=view&id=1-tC1sPCTNoB3xHtA02mQGKmtE3JRkJtz"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:54:39.087Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Nara/1.png",
        "image2": "/assets/images/heroes/afkarena/Nara/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:24:44.719Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Nara/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Nara/2.jpg"
    },
    {
        "_id": {
            "$oid": "6357f8d786e3949875a0c1ec"
        },
        "name": "Ferael",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ferael",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1c3jjTyB0YIpeWRiiXT0MhLBvXDEIGzA",
            "https://drive.google.com/uc?export=view&id=1qJOVrne7nuY5FBgblqifK9bdqGuWcYXP",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1c3jjTyB0YIpeWRiiXT0MhLBvXDEIGzA",
            "https://drive.google.com/uc?export=view&id=1qJOVrne7nuY5FBgblqifK9bdqGuWcYXP"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:55:19.892Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Ferael/1.png",
        "image2": "/assets/images/heroes/afkarena/Ferael/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:16:45.063Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Ferael/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Ferael/2.jpg"
    },
    {
        "_id": {
            "$oid": "6357f8f086e3949875a0c1ef"
        },
        "name": "Baden",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "baden",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1CeLAZxQLdINO3nVbdJwCh0UHk4QuH-fM",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1CeLAZxQLdINO3nVbdJwCh0UHk4QuH-fM",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:55:44.612Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:17:06.116Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f91286e3949875a0c1f2"
        },
        "name": "Kelthur",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "kelthur",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1U84goLHeERHGP3PfZgANnaQjRHbDy1LAM",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1U84goLHeERHGP3PfZgANnaQjRHbDy1LAM",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:56:18.038Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:17:25.611Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f92e86e3949875a0c1f5"
        },
        "name": "Silas",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "silas",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1HmZAjL_gnogH--mRmcd4IRUd6_P1k_dv",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1HmZAjL_gnogH--mRmcd4IRUd6_P1k_dv",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:56:46.683Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:18:45.253Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f94486e3949875a0c1f8"
        },
        "name": "Oden",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "oden",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1-HgeVXEy_FxOz0s2edLI8or-hGgruozg",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1-HgeVXEy_FxOz0s2edLI8or-hGgruozg",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:57:08.692Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:27:41.478Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f95b86e3949875a0c1fb"
        },
        "name": "Izold",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "izold",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Ry387_eIy4vYbF9ubcsTZ8j5hQWc3dvh",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Ry387_eIy4vYbF9ubcsTZ8j5hQWc3dvh",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:57:31.755Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:17:45.19Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f96f86e3949875a0c1fe"
        },
        "name": "Torne",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "torne",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=10RTX94L-njhWadsGiBEC2b0S4PtR2bwD",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=10RTX94L-njhWadsGiBEC2b0S4PtR2bwD",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:57:51.025Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:13:45.068Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f98386e3949875a0c201"
        },
        "name": "Daimon",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "daimon",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1nQ6--F4JC25o9KTZZ-5bcBtIRUxHGg2j",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1nQ6--F4JC25o9KTZZ-5bcBtIRUxHGg2j",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:58:11.875Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:18:08.479Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f99a86e3949875a0c204"
        },
        "name": "Theowyn",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "theowyn",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1kn6booPmaB0RTB_X16M_b9Gb9Lz0Q9nl",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1kn6booPmaB0RTB_X16M_b9Gb9Lz0Q9nl",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:58:34.329Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:13:13.001Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f9ad86e3949875a0c207"
        },
        "name": "Desira",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "desira",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1jrklw2qb2HBAm5kSVAtIx2E3WDlkxYSd",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1jrklw2qb2HBAm5kSVAtIx2E3WDlkxYSd",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:58:53.989Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:19:00.483Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f9c486e3949875a0c20a"
        },
        "name": "Hodgkin",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "hodgkin",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1BaBcQeblQX5UuHx25VCuOI9Y_eqkDte2",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1BaBcQeblQX5UuHx25VCuOI9Y_eqkDte2",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:59:16.863Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:19:16.901Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f9dc86e3949875a0c20d"
        },
        "name": "Treznor",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "treznor",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1C85XGNEjQkqEqeLGpeSlPa8BI_VIoKrw",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1C85XGNEjQkqEqeLGpeSlPa8BI_VIoKrw",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T14:59:40.493Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T04:45:25.337Z"
        }
    },
    {
        "_id": {
            "$oid": "6357f9f186e3949875a0c210"
        },
        "name": "Fane",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "fane",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=19unGZcpB_yJylgzv5lLg_uavl8jgmFYA",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=19unGZcpB_yJylgzv5lLg_uavl8jgmFYA",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "hotro",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:00:01.466Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:19:39.73Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fa0986e3949875a0c213"
        },
        "name": "Kalene",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "kalene",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1fyCYHpkGTcLriudbCpMX1xDjqNkOuhAJ",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1fyCYHpkGTcLriudbCpMX1xDjqNkOuhAJ",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "xacuop",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:00:25.092Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:19:53.846Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fadb86e3949875a0c218"
        },
        "name": "Athalia",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "athalia",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1Z5B-boXCg3t5oKFqKsE9dGFxa_xGY8Yw",
            "https://drive.google.com/uc?export=view&id=1TkPr7HMD75zC6OFN7pP_KfyyMtCSw9Ns",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1Z5B-boXCg3t5oKFqKsE9dGFxa_xGY8Yw",
            "https://drive.google.com/uc?export=view&id=1TkPr7HMD75zC6OFN7pP_KfyyMtCSw9Ns"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:03:55.515Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Athalia/1.png",
        "image2": "/assets/images/heroes/afkarena/Athalia/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T14:20:35.47Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Athalia/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Athalia/2.jpg"
    },
    {
        "_id": {
            "$oid": "6357fb1186e3949875a0c21b"
        },
        "name": "Elijah & Lailah",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "elijah-&-lailah",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1lnbKyDZGyg3BBLJWXF3VtNfhQWxELqD1",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1lnbKyDZGyg3BBLJWXF3VtNfhQWxELqD1",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:04:49.101Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:21:03.138Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fb2d86e3949875a0c21e"
        },
        "name": "Orthros",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "orthros",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1KmU8PlNMoiVCKeqjvVn8vqycOZCCgj8P",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1KmU8PlNMoiVCKeqjvVn8vqycOZCCgj8P",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:05:17.867Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:27:26.167Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fb4686e3949875a0c221"
        },
        "name": "Talene",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "talene",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hM4ZoaHrltljg7JyJW12qxmKgPDrkJTq",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hM4ZoaHrltljg7JyJW12qxmKgPDrkJTq",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "hotro",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:05:42.299Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:15:00.563Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fb9086e3949875a0c224"
        },
        "name": "King Kong",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "king-kong",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1FTH4i2nAwoG5hRzDFNTK7bGFAntm4AzZ",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1FTH4i2nAwoG5hRzDFNTK7bGFAntm4AzZ",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:06:56.268Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:37:09.036Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fba486e3949875a0c227"
        },
        "name": "Flora",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "flora",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1iDpqdPeuLF5XdNH6oE47irNJRAYRIiex",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1iDpqdPeuLF5XdNH6oE47irNJRAYRIiex",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:07:16.013Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:21:25.715Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fbbe86e3949875a0c22a"
        },
        "name": "Zaphrael",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "zaphrael",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1VyqZ8zqRJxhmBQ3LO1G89HVqraDW_hgk",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1VyqZ8zqRJxhmBQ3LO1G89HVqraDW_hgk",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:07:42.899Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "https://drive.google.com/uc?export=view&id=1VyqZ8zqRJxhmBQ3LO1G89HVqraDW_hgk",
        "image2": "/assets/images/products/clothes/3.png",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T02:05:32.128Z"
        },
        "thumbImage1": "https://drive.google.com/uc?export=view&id=1VyqZ8zqRJxhmBQ3LO1G89HVqraDW_hgk",
        "thumbImage2": "/assets/images/products/clothes/3.png"
    },
    {
        "_id": {
            "$oid": "6357fbd686e3949875a0c22d"
        },
        "name": "Alna",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "alna",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1hT2whtNsx8i3IgLVE64qkDtDxLC6TJy0",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1hT2whtNsx8i3IgLVE64qkDtDxLC6TJy0",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:08:06.247Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:21:58.092Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fbec86e3949875a0c230"
        },
        "name": "Morael",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "morael",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1sMM08zxkqJ21zYMrsHQ7z0vUoMm9ZT9e",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1sMM08zxkqJ21zYMrsHQ7z0vUoMm9ZT9e",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:08:28.86Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:29:33.006Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fc0f86e3949875a0c233"
        },
        "name": "Titus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "titus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=12xKVA3gjAqLffApWGswFRT_Ag-W0Jwoj",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=12xKVA3gjAqLffApWGswFRT_Ag-W0Jwoj",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:09:03.882Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:10:52.99Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fc2286e3949875a0c236"
        },
        "name": "Haelus",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "haelus",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1rmpmQDk6a_H2RuyuukAWOB0l1gkTSJpw",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1rmpmQDk6a_H2RuyuukAWOB0l1gkTSJpw",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:09:22.846Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:22:28.754Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fc3c86e3949875a0c239"
        },
        "name": "Talene*",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "talene*",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1s-z9QPNO9lV14MOhNtr4RfwzyxfsLP_t",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1s-z9QPNO9lV14MOhNtr4RfwzyxfsLP_t",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "dodon",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:09:48.192Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:17:00.762Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fc6186e3949875a0c23c"
        },
        "name": "Audrae",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "audrae",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1uDCSlcr8rmoRPyX30WvpG19bwG63tlaY",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1uDCSlcr8rmoRPyX30WvpG19bwG63tlaY",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:10:25.646Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:22:48.076Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fc7a86e3949875a0c23f"
        },
        "name": "Tarnos",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "tarnos",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1IFl4_mWjYgckqjd6VvxZV2nJlD6C1lQl",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1IFl4_mWjYgckqjd6VvxZV2nJlD6C1lQl",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "thanthanh",
        "species": "chienbinh",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:10:50.602Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:16:41.527Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fd1c86e3949875a0c242"
        },
        "name": "Ezizh",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ezizh",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1CiLgYxVRmEAPOQAG3JdKVtiRsB4IURsE",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1CiLgYxVRmEAPOQAG3JdKVtiRsB4IURsE",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "hotro",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:13:32.965Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:23:09.525Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fd5186e3949875a0c245"
        },
        "name": "Mehira",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "mehira",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1qwOWVJ_HSlMrJ5nEKNGnFNcbuCDBumaH",
            "https://drive.google.com/uc?export=view&id=1SXFFHBRZ7X82UNrokaXPXbgBnbTe5v90",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1qwOWVJ_HSlMrJ5nEKNGnFNcbuCDBumaH",
            "https://drive.google.com/uc?export=view&id=1SXFFHBRZ7X82UNrokaXPXbgBnbTe5v90"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:14:25.532Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "image1": "/assets/images/heroes/afkarena/Mehira/1.png",
        "image2": "/assets/images/heroes/afkarena/Mehira/2.jpg",
        "image3": "/assets/images/products/clothes/3.png",
        "image4": "/assets/images/products/clothes/4.png",
        "modified": {
            "$date": "2022-11-03T06:36:07.002Z"
        },
        "thumbImage1": "/assets/images/heroes/afkarena/Mehira/1.png",
        "thumbImage2": "/assets/images/heroes/afkarena/Mehira/2.jpg"
    },
    {
        "_id": {
            "$oid": "6357fd6d86e3949875a0c248"
        },
        "name": "Zolrath",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "zolrath",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1cl6gADK7-trb3JMZc55cXPPNdG8R3YH6",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1cl6gADK7-trb3JMZc55cXPPNdG8R3YH6",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:14:53.703Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6357fd8086e3949875a0c24b"
        },
        "name": "Khazard",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "khazard",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1-nh6p2F9YxJGuNsocK3hEGeyU5V3l1VC",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1-nh6p2F9YxJGuNsocK3hEGeyU5V3l1VC",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:15:12.488Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:36:48.625Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fd9b86e3949875a0c24e"
        },
        "name": "Mezoth",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "mezoth",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1MkTKxRZ4YbIDqKVOU16RxndnL6JBe9Tt",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1MkTKxRZ4YbIDqKVOU16RxndnL6JBe9Tt",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:15:39.523Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:28:20.619Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fdae86e3949875a0c251"
        },
        "name": "Lucretia",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "lucretia",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1EfOZRFJG4vn4NW09gbB6On49T66WbfpH",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1EfOZRFJG4vn4NW09gbB6On49T66WbfpH",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:15:58.838Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:23:49.818Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fdc286e3949875a0c254"
        },
        "name": "Mortas",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "mortas",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1k2eNK5wk-gXXWeu7yTiCZcz0_y97eEMe",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1k2eNK5wk-gXXWeu7yTiCZcz0_y97eEMe",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "hotro",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:16:18.026Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:30:56.154Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fdd786e3949875a0c257"
        },
        "name": "Leofric",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "leofric",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=15ujxiWqwCnpWE--GLSyOT8-OEBIruSg-",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=15ujxiWqwCnpWE--GLSyOT8-OEBIruSg-",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "hotro",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:16:39.077Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:35:00.113Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fde686e3949875a0c25a"
        },
        "name": "Zikis",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "zikis",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1ZN65NsvuWbGuwTouO9XqlAedv1Bb7Vwa",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1ZN65NsvuWbGuwTouO9XqlAedv1Bb7Vwa",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "xathu",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:16:54.811Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:24:10.835Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fdf686e3949875a0c25d"
        },
        "name": "Framton",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "framton",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1NzZuSKUTqPfbXacZQSrxLdRKT6xz-9sh",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1NzZuSKUTqPfbXacZQSrxLdRKT6xz-9sh",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "chienbinh",
        "type": "Agility",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:17:10.411Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:24:26.906Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fe0786e3949875a0c260"
        },
        "name": "Ezizh*",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "ezizh*",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1CiLgYxVRmEAPOQAG3JdKVtiRsB4IURsE",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1CiLgYxVRmEAPOQAG3JdKVtiRsB4IURsE",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:17:27.996Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:24:43.266Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fe2086e3949875a0c263"
        },
        "name": "Vyloris",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "vyloris",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1n9wRqm6tiDAoqbrkSekg2PnBkZa56Omo",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1n9wRqm6tiDAoqbrkSekg2PnBkZa56Omo",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "phapsu",
        "type": "Intelligence",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:17:52.614Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T06:08:43.616Z"
        }
    },
    {
        "_id": {
            "$oid": "6357fe3b86e3949875a0c266"
        },
        "name": "Canisa & Ruke",
        "category": "afkarena",
        "subCategory": "heroes",
        "slug": "canisa-&-ruke",
        "rate": 3,
        "price": 3,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "https://drive.google.com/uc?export=view&id=1unrw9P9zlgk2gURC3dUawFSiRUEp01ZU",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "https://drive.google.com/uc?export=view&id=1unrw9P9zlgk2gURC3dUawFSiRUEp01ZU",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "nguoidianguc",
        "species": "dodon",
        "type": "Strength",
        "grade": "3",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-10-25T15:18:19.397Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-03T14:24:59.932Z"
        }
    },
    {
        "_id": {
            "$oid": "6363d6c089fd64e53b045512"
        },
        "name": "Heavenly Sword",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Heavenly-Sword",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Attacks with a heavenly sword, removing a beneficial effect on the enemy with a 75% chance. The damage increases according to your Defense",
        "details": "More Information",
        "images": [
            "/assets/images/skills/skill1/Heavenly_Sword_Fire.png",
            "/assets/images/skills/remove_benefit_effect.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill1/Heavenly_Sword_Fire.png",
            "/assets/images/skills/remove_benefit_effect.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-03T14:57:04.29Z"
        },
        "createdBy": "Hung Nguyen",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "6363d70189fd64e53b04551b"
        },
        "name": "Punishment",
        "category": "summonerswar",
        "subCategory": "skills",
        "slug": "Punishment",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Deals damage with flames of punishment and inflicts Continuous Damage for 3 turns. The initial damage increases according to Defense. (Reusable in 4 turns)",
        "details": "More Information",
        "images": [
            "/assets/images/skills/skill2/Punishment_Fire.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/skills/Reduce-DEF.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/skills/skill2/Punishment_Fire.png",
            "/assets/images/skills/Continuous-Damage.png",
            "/assets/images/skills/Reduce-DEF.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Skill",
        "type": "Active",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-03T14:58:09.569Z"
        },
        "createdBy": "Hung Nguyen",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "636c5bc0fbddc84b5cf8781b"
        },
        "name": "gameministress",
        "category": "game",
        "subCategory": "gamemini",
        "slug": "gameministress",
        "rate": 5,
        "price": 6,
        "quantity": 6,
        "description": "",
        "details": "{\n    \"items\":[\n        {\"data\":[2,1],\"active\":true,\"max\":1,\"type\":1},\n        {\"data\":[3,2,1],\"active\":true,\"max\":2,\"type\":1},\n        {\"data\":[4,5,3,2,1],\"active\":true,\"max\":3,\"type\":1},\n        {\"data\":[4,5,3,2,1,6,7],\"active\":true,\"max\":3,\"type\":1},\n        {\"data\":[6,4,3,5,2,1,7],\"active\":true,\"max\":4,\"type\":1},\n        {\"data\":[5,7,4,3,2,6,1],\"active\":true,\"max\":5,\"type\":1},\n        {\"data\":[5,-2,23,7,87,-42,509],\"active\":true,\"max\":3,\"type\":1},\n        {\"data\":[13, 7, 6, 45, 21, 9, 101, 102],\"active\":true,\"max\":4,\"type\":1},\n        {\"data\":[100, 45, 21, 13, 9, 7, 6, 2],\"active\":true,\"max\":7,\"type\":1},\n        {\"data\":[5, \"–\", 8,\"= 3\"],\"active\":true,\"max\":2,\"type\":2},\n        {\"data\":[\"+\", 1, 2,\"= 3\"],\"active\":true,\"max\":1,\"type\":2},\n        {\"data\":[\"+\", 1, 2, \"-\", 3,\"= 0\"],\"active\":true,\"max\":1,\"type\":2},\n        {\"data\":[\"+\", 1, 2, \"-\", 3, \"x\", 4, \"+\", 5, \"= 4\"],\"active\":true,\"max\":4,\"type\":2},\n        {\"data\":[5, \"–\", 8, \"x\", 9, \"x\", 2, \"x\", 6, \"+\", 10, \"–\", 4, \"x\", 3, \"x\",7, \"–\", 1,\"= 2021\"],\"active\":true,\"max\":5,\"type\":2}\n    ],\n    \"itemsBackup\":[\n        {\"data\":[2,1],\"active\":true,\"max\":1,\"type\":1},\n        {\"data\":[3,2,1],\"active\":true,\"max\":2,\"type\":1},\n        {\"data\":[4,5,3,2,1],\"active\":true,\"max\":3,\"type\":1},\n        {\"data\":[4,5,3,2,1,6,7],\"active\":true,\"max\":3,\"type\":1},\n        {\"data\":[6,4,3,5,2,1,7],\"active\":true,\"max\":4,\"type\":1},\n        {\"data\":[5,7,4,3,2,6,1],\"active\":true,\"max\":5,\"type\":1},\n        {\"data\":[5,-2,23,7,87,-42,509],\"active\":true,\"max\":3,\"type\":1},\n        {\"data\":[13, 7, 6, 45, 21, 9, 101, 102],\"active\":true,\"max\":4,\"type\":1},\n        {\"data\":[100, 45, 21, 13, 9, 7, 6, 2],\"active\":true,\"max\":7,\"type\":1},\n        {\"data\":[5, \"–\", 8,\"= 3\"],\"active\":true,\"max\":2,\"type\":2},\n        {\"data\":[\"+\", 1, 2,\"= 3\"],\"active\":true,\"max\":1,\"type\":2},\n        {\"data\":[\"+\", 1, 2, \"-\", 3,\"= 0\"],\"active\":true,\"max\":1,\"type\":2},\n        {\"data\":[\"+\", 1, 2, \"-\", 3, \"x\", 4, \"+\", 5, \"= 4\"],\"active\":true,\"max\":4,\"type\":2},\n        {\"data\":[5, \"–\", 8, \"x\", 9, \"x\", 2, \"x\", 6, \"+\", 10, \"–\", 4, \"x\", 3, \"x\",7, \"–\", 1,\"= 2021\"],\"active\":true,\"max\":5,\"type\":2}\n    ],\n    \"itemsResult\":[\n        {\"data\":[1,2]},\n        {\"data\":[1,2,3]},\n        {\"data\":[1,2,3,4,5]},\n        {\"data\":[1,2,3,4,5,6,7]},\n        {\"data\":[1,2,3,4,5,6,7]},\n        {\"data\":[1,2,3,4,5,6,7]},\n        {\"data\":[-42,-2,5,7,23,87,509]},\n        {\"data\":[6, 7, 9, 13, 21, 45, 101, 102]},\n        {\"data\":[2,6,7,9,13,21,45,100]},\n        {\"data\":[8, \"–\", 5,\"= 3\"]},\n        {\"data\":[1, \"+\", 2,\"= 3\"]},\n        {\"data\":[1, \"+\", 2, \"-\", 3,\"= 0\"]},\n        {\"data\":[4]},\n        {\"data\":[2021]}\n    ]\n}",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "assets/img/listing/img8.jpg",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-10T02:02:40.375Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-09T09:34:03.52Z"
        },
        "address": "",
        "city": "hochiminh",
        "keywords": "",
        "title": "gameministress"
    },
    {
        "_id": {
            "$oid": "6378bd887bff95e6d5121421"
        },
        "name": "Ducati Streetfighter V4",
        "keywords": "Ducati,Streetfighter,V4",
        "city": "hochiminh",
        "category": "other",
        "subCategory": "motobike",
        "slug": "ducati-streetfighter-v4",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information1",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-19T11:27:04.877Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Pending",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "address": "TẦNG 1, TÒA NHÀ PACKSIMEX, SỐ 52 ĐÔNG DU, PHƯỜNG BẾN NGHÉ, QUẬN 1, TP. HỒ CHÍ MINH",
        "modified": {
            "$date": "2022-11-19T12:46:51.303Z"
        }
    },
    {
        "_id": {
            "$oid": "6379fade6539bce49e01e11a"
        },
        "name": "DATA worldcup 2022",
        "keywords": "",
        "city": "hochiminh",
        "address": "",
        "category": "other",
        "subCategory": "match",
        "slug": "data-worldcup-2022",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "[{\"group\":\"A\",\"team\":[{\"name\":\"Hà Lan\",\"flag\":\"/assets/images/flags/hl.png\",\"win\":2,\"draw\":1,\"lose\":0,\"goals\":3,\"goals_conceded\":1},{\"name\":\"Sénégal\",\"flag\":\"/assets/images/flags/se.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":5,\"goals_conceded\":4},{\"name\":\"Ecuador\",\"flag\":\"/assets/images/flags/ec.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":6,\"goals_conceded\":3},{\"name\":\"Qatar\",\"flag\":\"/assets/images/flags/qt.png\",\"win\":0,\"draw\":0,\"lose\":3,\"goals\":1,\"goals_conceded\":7}]},{\"group\":\"B\",\"team\":[{\"name\":\"Anh\",\"flag\":\"/assets/images/flags/en.png\",\"win\":2,\"draw\":1,\"lose\":0,\"goals\":9,\"goals_conceded\":2},{\"name\":\"Mỹ\",\"flag\":\"/assets/images/flags/am.png\",\"win\":1,\"draw\":2,\"lose\":0,\"goals\":2,\"goals_conceded\":1},{\"name\":\"Iran\",\"flag\":\"/assets/images/flags/ir.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":4,\"goals_conceded\":7},{\"name\":\"Wales\",\"flag\":\"/assets/images/flags/we.png\",\"win\":0,\"draw\":1,\"lose\":2,\"goals\":1,\"goals_conceded\":6}]},{\"group\":\"C\",\"team\":[{\"name\":\"Argentina\",\"flag\":\"/assets/images/flags/ar.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":5,\"goals_conceded\":2},{\"name\":\"Ba Lan\",\"flag\":\"/assets/images/flags/bl.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":2,\"goals_conceded\":2},{\"name\":\"Mexico\",\"flag\":\"/assets/images/flags/mx.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":2,\"goals_conceded\":3},{\"name\":\"Ả Rập Xê Út\",\"flag\":\"/assets/images/flags/ksa.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":3,\"goals_conceded\":5}]},{\"group\":\"D\",\"team\":[{\"name\":\"Pháp\",\"flag\":\"/assets/images/flags/fe.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":6,\"goals_conceded\":3},{\"name\":\"Australia\",\"flag\":\"/assets/images/flags/uc.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":3,\"goals_conceded\":4},{\"name\":\"Tunisia\",\"flag\":\"/assets/images/flags/tu.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":1,\"goals_conceded\":1},{\"name\":\"Đan Mạch\",\"flag\":\"/assets/images/flags/dm.png\",\"win\":0,\"draw\":1,\"lose\":2,\"goals\":1,\"goals_conceded\":3}]},{\"group\":\"E\",\"team\":[{\"name\":\"Nhật Bản\",\"flag\":\"/assets/images/flags/jp.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":4,\"goals_conceded\":3},{\"name\":\"Tây Ban Nha\",\"flag\":\"/assets/images/flags/tbn.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":9,\"goals_conceded\":3},{\"name\":\"Đức\",\"flag\":\"/assets/images/flags/d.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":6,\"goals_conceded\":5},{\"name\":\"Costa Rica\",\"flag\":\"/assets/images/flags/cos.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":3,\"goals_conceded\":11}]},{\"group\":\"F\",\"team\":[{\"name\":\"Maroc\",\"flag\":\"/assets/images/flags/mar.png\",\"win\":2,\"draw\":1,\"lose\":0,\"goals\":4,\"goals_conceded\":1},{\"name\":\"Croatia\",\"flag\":\"/assets/images/flags/cro.png\",\"win\":1,\"draw\":2,\"lose\":0,\"goals\":4,\"goals_conceded\":1},{\"name\":\"Bỉ\",\"flag\":\"/assets/images/flags/bi.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":1,\"goals_conceded\":2},{\"name\":\"Canada\",\"flag\":\"/assets/images/flags/can.png\",\"win\":0,\"draw\":0,\"lose\":3,\"goals\":2,\"goals_conceded\":7}]},{\"group\":\"G\",\"team\":[{\"name\":\"Brasil\",\"flag\":\"/assets/images/flags/bra.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":3,\"goals_conceded\":1},{\"name\":\"Thụy Sĩ\",\"flag\":\"/assets/images/flags/ts.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":4,\"goals_conceded\":3},{\"name\":\"Cameroon\",\"flag\":\"/assets/images/flags/cam.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":4,\"goals_conceded\":4},{\"name\":\"Serbia\",\"flag\":\"/assets/images/flags/ser.png\",\"win\":0,\"draw\":1,\"lose\":2,\"goals\":5,\"goals_conceded\":7}]},{\"group\":\"H\",\"team\":[{\"name\":\"Bồ Đào Nha\",\"flag\":\"/assets/images/flags/bdn.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":6,\"goals_conceded\":4},{\"name\":\"Hàn Quốc\",\"flag\":\"/assets/images/flags/hq.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":4,\"goals_conceded\":4},{\"name\":\"Uruguay\",\"flag\":\"/assets/images/flags/uru.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":2,\"goals_conceded\":2},{\"name\":\"Ghana\",\"flag\":\"/assets/images/flags/gha.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":5,\"goals_conceded\":7}]}]",
        "details": "[{\"group\":\"MMS Tứ kết/Bán kết\",\"team\":[{\"name\":\"Hùng\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":3,\"draw\":0,\"lose\":3,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thua\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thua\",\"Bồ Đào Nha 0 - 1 Maroc: Thua\",\"Pháp 2 - 1 Anh: Thắng\",\"Argentina 3 - 0 Croatia: Thắng\",\"Pháp 2 - 0 Maroc: Thắng\"]},{\"name\":\"Mehdi\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":4,\"draw\":0,\"lose\":1,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thắng\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thua\",\"Pháp 2 - 1 Anh: Thắng\",\"Argentina 3 - 0 Croatia: Thắng\",\"Pháp 2 - 0 Maroc: Thắng\"]},{\"name\":\"Hào\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":0,\"draw\":0,\"lose\":2,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thua\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thua\"]},{\"name\":\"Sang\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":0,\"draw\":0,\"lose\":2,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thua\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thua\"]},{\"name\":\"Đạt\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":0,\"draw\":0,\"lose\":2,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thua\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thua\"]},{\"name\":\"Đăng\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":1,\"draw\":0,\"lose\":1,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thua\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thắng\"]},{\"name\":\"Nguyên\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":2,\"draw\":0,\"lose\":0,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 1 (2) - (4) 1 Croatia: Thắng\",\"Argentina 2 (4) - (3) 2 Hà Lan: Thắng\"]}]},{\"group\":\"MMS V16\",\"team\":[{\"name\":\"Hùng\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":3,\"draw\":0,\"lose\":5,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Argentina 2 - 1 Australia: Thua\",\"Hà Lan 3 - 1 Mỹ: Thua\",\"Pháp 3 - 1 Ba Lan: Thắng\",\"Anh 3 - 0 Senegal: Thua\",\"Brasil 4 - 1 Hàn Quốc: Thua\",\"Croatia 1 (3) - 1 Nhật Bản: Thắng\",\"Maroc 0(3) - 0 Tây Ban Nha: Thua\",\"Bồ Đào Nha 6 - 1 Thụy Sĩ: Thắng\"]},{\"name\":\"Hào\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":4,\"draw\":0,\"lose\":4,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Argentina 2 - 1 Australia: Thua\",\"Hà Lan 3 - 1 Mỹ: Thắng\",\"Pháp 3 - 1 Ba Lan: Thua\",\"Anh 3 - 0 Senegal: Thua\",\"Brasil 4 - 1 Hàn Quốc: Thắng\",\"Croatia 1 (3) - 1 Nhật Bản: Thắng\",\"Maroc 0(3) - 0 Tây Ban Nha: Thua\",\"Bồ Đào Nha 6 - 1 Thụy Sĩ: Thắng\"]},{\"name\":\"Mehdi\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":8,\"draw\":0,\"lose\":0,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Argentina 2 - 1 Australia: Thắng\",\"Hà Lan 3 - 1 Mỹ: Thắng\",\"Pháp 3 - 1 Ba Lan: Thắng\",\"Anh 3 - 0 Senegal: Thắng\",\"Brasil 4 - 1 Hàn Quốc: Thắng\",\"Croatia 1 (3) - 1 Nhật Bản: Thắng\",\"Maroc 0(3) - 0 Tây Ban Nha: Thắng\",\"Bồ Đào Nha 6 - 1 Thụy Sĩ: Thắng\"]},{\"name\":\"Sang\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":2,\"draw\":0,\"lose\":2,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Brasil 4 - 1 Hàn Quốc: Thắng\",\"Croatia 1 (3) - 1 Nhật Bản: Thua\",\"Maroc 0(3) - 0 Tây Ban Nha: Thua\",\"Bồ Đào Nha 6 - 1 Thụy Sĩ: Thắng\"]},{\"name\":\"Nguyên\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":2,\"draw\":0,\"lose\":2,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Pháp 3 - 1 Ba Lan: Thua\",\"Anh 3 - 0 Senegal: Thắng\",\"Brasil 4 - 1 Hàn Quốc: Thua\",\"Croatia 1 (3) - 1 Nhật Bản: Thắng\"]}]},{\"group\":\"MMS\",\"team\":[{\"name\":\"Hùng\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":9,\"draw\":0,\"lose\":14,\"goals\":0,\"goals_conceded\":0,\"details\":[\"England 6 - 2 Iran: Thắng\",\"Germany 1 - 2 Japan: Thắng\",\"Spain 7 - 0 Costa Rica: Thua\",\"Uruguay 0 - 0 Hàn Quốc: Thua\",\"Brasil 2 - 0 Serbia: Thua\",\"Hà Lan 1 - 1 Ecuador: Thua\",\"Wales 0 - 2 Iran: Thắng\",\"Pháp 2 - 1 Đan mạch: Thua\",\"Argentina 2 - 0 Mexico: Thua\",\"Nhật 0 - 1 Costa Rica: Thắng\",\"Tây Ban Nha 1- 1 Đức: Thua\",\"Hàn Quốc 2 - 3 Ghana: Thua\",\"Bồ Đào Nha 2 - 0 Uruguay: Thua\",\"Brazil 1 - 0 Thụy Sĩ: Thua\",\"Wales 0 - 3 Anh: Thua\",\"Iran 0 - 1 Mỹ: Thua\",\"Ecuador 1 - 2 Senegal: Thua\",\"Pháp 0 - 1 Tunisia: Thắng\",\"Tây Ban Nha 1 - 2 Nhật: Thắng\",\"Ma-rốc 2 - 1 Canada: Thắng\",\"Brazil 0 - 1 Cameroon: Thắng\",\"Bồ Đào Nha 1 - 2 Hàn Quốc: Thua\",\"Uruguay 2 - 0 Ghana: Thắng\"]},{\"name\":\"Hào\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":10,\"draw\":0,\"lose\":13,\"goals\":0,\"goals_conceded\":0,\"details\":[\"England 6 - 2 Iran: Thua\",\"Germany 1 - 2 Japan: Thua\",\"Spain 7 - 0 Costa Rica: Thắng\",\"Uruguay 0 - 0 Hàn Quốc: Thua\",\"Brasil 2 - 0 Serbia: Thắng\",\"Hà Lan 1 - 1 Ecuador: Thắng\",\"Wales 0 - 2 Iran: Thắng\",\"Pháp 2 - 1 Đan mạch: Thua\",\"Argentina 2 - 0 Mexico: Thắng\",\"Nhật 0 - 1 Costa Rica: Thua\",\"Tây Ban Nha 1- 1 Đức: Thắng\",\"Hàn Quốc 2 - 3 Ghana: Thua\",\"Bồ Đào Nha 2 - 0 Uruguay: Thắng\",\"Iran 0 - 1 Mỹ: Thua\",\"Ecuador 1 - 2 Senegal: Thua\",\"Hà Lan 2 - 0 Qatar: Thắng\",\"Pháp 0 - 1 Tunisia: Thua\",\"Đan Mạch 0 - 1 Australia: Thua\",\"Argentina 2 - 0 Ba Lan: Thắng\",\"Saudi Arabia 1 - 2 Mexico: Thua\",\"Đức 4 -2  Costa Rica: Thua\",\"Tây Ban Nha 1 - 2 Nhật: Thắng\",\"Brazil 0 - 1 Cameroon: Thua\"]},{\"name\":\"Nguyên\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":7,\"draw\":0,\"lose\":12,\"goals\":0,\"goals_conceded\":0,\"details\":[\"England 6 - 2 Iran u: Thắng\",\"Germany 1 - 2 Japan : Thắng\",\"Spain 7 - 0 Costa Rica: Thua\",\"Uruguay 0 - 0 Hàn Quốc: Thua\",\"Brasil 2 - 0 Serbia: Thua\",\"Hà Lan 1 - 1 Ecuador: Thua\",\"Wales 0 - 2 Iran: Thua\",\"Pháp 2 - 1 Đan mạch: Thắng\",\"Argentina 2 - 0 Mexico: Thua\",\"Nhật 0 - 1 Costa Rica: Thua\",\"Tây Ban Nha 1- 1 Đức: Thua\",\"Hàn Quốc 2 - 3 Ghana: Thắng\",\"Bồ Đào Nha 2 - 0 Uruguay: Thua\",\"Brazil 1 - 0 Thụy Sĩ: Thắng\",\"Saudi Arabia 1 - 2 Mexico: Thua\",\"Đức 4 -2  Costa Rica: Thắng\",\"Tây Ban Nha 1 - 2 Nhật: Thắng\",\"Ma-rốc 2 - 1 Canada: Thua\",\"Croatia 0 - 0 Bỉ: Thua\"]},{\"name\":\"Đăng\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":11,\"draw\":0,\"lose\":7,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Germany 1 - 2 Japan : Thua\",\"Spain 7 - 0 Costa Rica: Thua\",\"Uruguay 0 - 0 Hàn Quốc: Thắng\",\"Brasil 2 - 0 Serbia: Thắng\",\"Hà Lan 1 - 1 Ecuador: Thắng\",\"Wales 0 - 2 Iran: Thua\",\"Cameroon 3 - 3 Serbia: Thắng\",\"Hàn Quốc 2 - 3 Ghana: Thắng\",\"Bồ Đào Nha 2 - 0 Uruguay: Thắng\",\"Brazil 1 - 0 Thụy Sĩ: Thắng\",\"Wales 0 - 3 Anh: Thắng\",\"Iran 0 - 1 Mỹ: Thắng\",\"Đức 4 -2  Costa Rica: Thắng\",\"Tây Ban Nha 1 - 2 Nhật: Thua\",\"Ma-rốc 2 - 1 Canada: Thua\",\"Croatia 0 - 0 Bỉ: Thắng\",\"Brazil 0 - 1 Cameroon: Thua\",\"Bồ Đào Nha 1 - 2 Hàn Quốc: Thua\"]},{\"name\":\"Sang\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":11,\"draw\":0,\"lose\":6,\"goals\":0,\"goals_conceded\":0,\"details\":[\"England 6 - 2 Iran : Thắng\",\"Germany 1 - 2 Japan : Thua\",\"Spain 7 - 0 Costa Rica: Thắng\",\"Uruguay 0 - 0 Hàn Quốc: Thắng\",\"Brasil 2 - 0 Serbia: Thắng\",\"Hà Lan 1 - 1 Ecuador: Thắng\",\"Wales 0 - 2 Iran: Thua\",\"Bồ Đào Nha 2 - 0 Uruguay: Thắng\",\"Brazil 1 - 0 Thụy Sĩ: Thắng\",\"Ecuador 1 - 2 Senegal: Thắng\",\"Hà Lan 2 - 0 Qatar: Thắng\",\"Pháp 0 - 1 Tunisia: Thua\",\"Đan Mạch 0 - 1 Australia: Thua\",\"Ma-rốc 2 - 1 Canada: Thắng\",\"Croatia 0 - 0 Bỉ: Thắng\",\"Brazil 0 - 1 Cameroon: Thua\",\"Uruguay 2 - 0 Ghana: Thua\"]},{\"name\":\"Đạt\",\"flag\":\"/assets/images/flags/default.jpg\",\"win\":10,\"draw\":0,\"lose\":4,\"goals\":0,\"goals_conceded\":0,\"details\":[\"Germany 1 - 2 Japan : Thua\",\"Spain 7 - 0 Costa Rica: Thắng\",\"Uruguay 0 - 0 Hàn Quốc: Thắng\",\"Brasil 2 - 0 Serbia: Thắng\",\"Hà Lan 1 - 1 Ecuador: Thắng\",\"Wales 0 - 2 Iran: Thua\",\"Bồ Đào Nha 2 - 0 Uruguay: Thắng\",\"Brazil 1 - 0 Thụy Sĩ: Thắng\",\"Iran 0 - 1 Mỹ: Thắng\",\"Ecuador 1 - 2 Senegal: Thua\",\"Hà Lan 2 - 0 Qatar: Thắng\",\"Đức 4 -2  Costa Rica: Thắng\",\"Tây Ban Nha 1 - 2 Nhật: Thua\",\"Croatia 0 - 0 Bỉ: Thắng\"]}]},{\"group\":\"A\",\"team\":[{\"name\":\"Hà Lan\",\"flag\":\"/assets/images/flags/hl.png\",\"win\":2,\"draw\":1,\"lose\":0,\"goals\":3,\"goals_conceded\":1},{\"name\":\"Sénégal\",\"flag\":\"/assets/images/flags/se.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":5,\"goals_conceded\":4},{\"name\":\"Ecuador\",\"flag\":\"/assets/images/flags/ec.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":6,\"goals_conceded\":3},{\"name\":\"Qatar\",\"flag\":\"/assets/images/flags/qt.png\",\"win\":0,\"draw\":0,\"lose\":3,\"goals\":1,\"goals_conceded\":7}]},{\"group\":\"B\",\"team\":[{\"name\":\"Anh\",\"flag\":\"/assets/images/flags/en.png\",\"win\":2,\"draw\":1,\"lose\":0,\"goals\":9,\"goals_conceded\":2},{\"name\":\"Mỹ\",\"flag\":\"/assets/images/flags/am.png\",\"win\":1,\"draw\":2,\"lose\":0,\"goals\":2,\"goals_conceded\":1},{\"name\":\"Iran\",\"flag\":\"/assets/images/flags/ir.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":4,\"goals_conceded\":7},{\"name\":\"Wales\",\"flag\":\"/assets/images/flags/we.png\",\"win\":0,\"draw\":1,\"lose\":2,\"goals\":1,\"goals_conceded\":6}]},{\"group\":\"C\",\"team\":[{\"name\":\"Argentina\",\"flag\":\"/assets/images/flags/ar.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":5,\"goals_conceded\":2},{\"name\":\"Ba Lan\",\"flag\":\"/assets/images/flags/bl.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":2,\"goals_conceded\":2},{\"name\":\"Mexico\",\"flag\":\"/assets/images/flags/mx.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":2,\"goals_conceded\":3},{\"name\":\"Ả Rập Xê Út\",\"flag\":\"/assets/images/flags/ksa.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":3,\"goals_conceded\":5}]},{\"group\":\"D\",\"team\":[{\"name\":\"Pháp\",\"flag\":\"/assets/images/flags/fe.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":6,\"goals_conceded\":3},{\"name\":\"Australia\",\"flag\":\"/assets/images/flags/uc.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":3,\"goals_conceded\":4},{\"name\":\"Tunisia\",\"flag\":\"/assets/images/flags/tu.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":1,\"goals_conceded\":1},{\"name\":\"Đan Mạch\",\"flag\":\"/assets/images/flags/dm.png\",\"win\":0,\"draw\":1,\"lose\":2,\"goals\":1,\"goals_conceded\":3}]},{\"group\":\"E\",\"team\":[{\"name\":\"Nhật Bản\",\"flag\":\"/assets/images/flags/jp.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":4,\"goals_conceded\":3},{\"name\":\"Tây Ban Nha\",\"flag\":\"/assets/images/flags/tbn.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":9,\"goals_conceded\":3},{\"name\":\"Đức\",\"flag\":\"/assets/images/flags/d.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":6,\"goals_conceded\":5},{\"name\":\"Costa Rica\",\"flag\":\"/assets/images/flags/cos.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":3,\"goals_conceded\":11}]},{\"group\":\"F\",\"team\":[{\"name\":\"Maroc\",\"flag\":\"/assets/images/flags/mar.png\",\"win\":2,\"draw\":1,\"lose\":0,\"goals\":4,\"goals_conceded\":1},{\"name\":\"Croatia\",\"flag\":\"/assets/images/flags/cro.png\",\"win\":1,\"draw\":2,\"lose\":0,\"goals\":4,\"goals_conceded\":1},{\"name\":\"Bỉ\",\"flag\":\"/assets/images/flags/bi.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":1,\"goals_conceded\":2},{\"name\":\"Canada\",\"flag\":\"/assets/images/flags/can.png\",\"win\":0,\"draw\":0,\"lose\":3,\"goals\":2,\"goals_conceded\":7}]},{\"group\":\"G\",\"team\":[{\"name\":\"Brasil\",\"flag\":\"/assets/images/flags/bra.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":3,\"goals_conceded\":1},{\"name\":\"Thụy Sĩ\",\"flag\":\"/assets/images/flags/ts.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":4,\"goals_conceded\":3},{\"name\":\"Cameroon\",\"flag\":\"/assets/images/flags/cam.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":4,\"goals_conceded\":4},{\"name\":\"Serbia\",\"flag\":\"/assets/images/flags/ser.png\",\"win\":0,\"draw\":1,\"lose\":2,\"goals\":5,\"goals_conceded\":7}]},{\"group\":\"H\",\"team\":[{\"name\":\"Bồ Đào Nha\",\"flag\":\"/assets/images/flags/bdn.png\",\"win\":2,\"draw\":0,\"lose\":1,\"goals\":6,\"goals_conceded\":4},{\"name\":\"Hàn Quốc\",\"flag\":\"/assets/images/flags/hq.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":4,\"goals_conceded\":4},{\"name\":\"Uruguay\",\"flag\":\"/assets/images/flags/uru.png\",\"win\":1,\"draw\":1,\"lose\":1,\"goals\":2,\"goals_conceded\":2},{\"name\":\"Ghana\",\"flag\":\"/assets/images/flags/gha.png\",\"win\":1,\"draw\":0,\"lose\":2,\"goals\":5,\"goals_conceded\":7}]}]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "assets/img/listing/img8.jpg"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-20T10:01:02.497Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:20:40.315Z"
        },
        "title": "DATA worldcup 2022"
    },
    {
        "_id": {
            "$oid": "637dd9e2be7ca3dbb5bf54ed"
        },
        "name": "The Deck Saigon",
        "keywords": "",
        "city": "hochiminh",
        "address": "",
        "category": "realestate",
        "subCategory": "restaurants",
        "slug": "the-deck-saigon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637dd9e2be7ca3dbb5bf54ed_background0.jpeg?1670252284828"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T08:29:22.669Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "active",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T04:11:46.452Z"
        },
        "title": "The Deck Saigon",
        "ApiKey": null,
        "FacebookURL": null,
        "InstagramURL": null,
        "LinkedinURL": null,
        "TwitterURL": null,
        "email": null,
        "mapLatitude": null,
        "mapLongitude": null,
        "phone": null,
        "promoVideoVimeo": null,
        "promoVideoYoutube": null,
        "videoVimeo": null,
        "videoYoutube": null,
        "website": null
    },
    {
        "_id": {
            "$oid": "637ddb3abe7ca3dbb5bf54f7"
        },
        "name": "New World Saigon Hotel",
        "keywords": "",
        "city": "hochiminh",
        "address": "76 Đ. Lê Lai, Phường Bến Thành, Quận 1",
        "category": "realestate",
        "subCategory": "hotels",
        "slug": "new-world-saigon-hotel",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637ddb3abe7ca3dbb5bf54f7_background0.jpeg?1670251996730"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T08:35:06.477Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "active",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T04:39:08.34Z"
        },
        "title": "New World Saigon Hotel",
        "ApiKey": null,
        "FacebookURL": null,
        "InstagramURL": null,
        "LinkedinURL": null,
        "TwitterURL": null,
        "email": null,
        "mapLatitude": null,
        "mapLongitude": null,
        "phone": null,
        "promoVideoVimeo": null,
        "promoVideoYoutube": null,
        "videoVimeo": null,
        "videoYoutube": null,
        "website": null
    },
    {
        "_id": {
            "$oid": "637e16507314986b3b944f1a"
        },
        "name": "Qatar - Ecuador",
        "title": "Qatar 0 - 2 Ecuador",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "qatar---ecuador",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "Enner Valencia 16', 31'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e16507314986b3b944f1a_background0.png?1669208545931",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group A",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T12:47:12.365Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-25T02:11:24.745Z"
        },
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=YtvePnAxYCk",
        "species": "23h00 20/11/2022"
    },
    {
        "_id": {
            "$oid": "637e1af77314986b3b944f52"
        },
        "name": "Anh - Iran",
        "title": "Anh 6 - 2 Iran",
        "address": "Khalifa International Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "anh---iran",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Anh chấp Iran 1.5 trái",
        "details": "England 35' 43' 62' 45+1' 71' 90' Iran 65' 90+13'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e1af77314986b3b944f52_background0.png?1669209055592",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group B",
        "type": "Hùng, Nguyên, Sang",
        "grade": "Hào",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:07:03.532Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=u_f0Wihq2Xw",
        "modified": {
            "$date": "2022-12-20T03:18:16.501Z"
        },
        "species": "20h00 21/11/2022"
    },
    {
        "_id": {
            "$oid": "637e1c3a7314986b3b944f78"
        },
        "name": "Sénégal - Hà Lan",
        "title": "Sénégal 0 - 2 Hà Lan",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "sénégal---hà-lan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "Cody Gakpo 84' Davy Klaassen 90+9'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e1c3a7314986b3b944f78_background0.png?1669209192648",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group A",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:12:26.826Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=nvKnVVksSis",
        "modified": {
            "$date": "2022-12-20T03:17:07.182Z"
        },
        "species": "23h00 21/11/2022"
    },
    {
        "_id": {
            "$oid": "637e1ccb7314986b3b944f86"
        },
        "name": "Mỹ - Wales",
        "title": "Mỹ 1 - 1 Wales",
        "address": "Ahmed bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "mỹ---wales",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "USA 36' Wales 82'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e1ccb7314986b3b944f86_background0.png?1669209410656",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group B",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:14:51.267Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=1qjgILBOIDM",
        "modified": {
            "$date": "2022-11-25T02:52:32.229Z"
        },
        "species": "02h00 22/11/2022"
    },
    {
        "_id": {
            "$oid": "637e1e0e7314986b3b944fa4"
        },
        "name": "Argentina - Saudi Arabia",
        "title": "Argentina 1 - 2 Saudi Arabia",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "argentina---saudi-arabia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "Argentina 10' Saudi Arabia 48' 53'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e1e0e7314986b3b944fa4_background0.png?1669209632136",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group C",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:20:14.268Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=23u4iy7vSvI",
        "modified": {
            "$date": "2022-11-25T02:12:24.905Z"
        },
        "species": "17h00 22/11/2022"
    },
    {
        "_id": {
            "$oid": "637e1e867314986b3b944fb2"
        },
        "name": "Đan Mạch - Tunisia",
        "title": "Đan Mạch 0 - 0 Tunisia",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "đan-mạch---tunisia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e1e867314986b3b944fb2_background0.png?1669209749548",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group D",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:22:14.685Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=BJWhEWjA17g",
        "modified": {
            "$date": "2022-12-20T03:22:06.652Z"
        },
        "species": "20h00 22/11/2022"
    },
    {
        "_id": {
            "$oid": "637e21417314986b3b944fcc"
        },
        "name": "Mexico - Poland",
        "title": "Mexico 0 - 0 Poland",
        "address": "Stadium 974 (Rass Abou Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "mexico---poland",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e21417314986b3b944fcc_background0.png?1669210446628",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group C",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:33:53.268Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=4V-MNWx9M4I",
        "modified": {
            "$date": "2022-11-25T02:12:39.122Z"
        },
        "species": "23h00 22/11/2022"
    },
    {
        "_id": {
            "$oid": "637e21957314986b3b944fda"
        },
        "name": "France - Australia",
        "title": "France 4 - 1 Australia",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "france---australia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "France 27' 32' 71' 68' Australia 9'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e21957314986b3b944fda_background0.png?1669210541189",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group D",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:35:17.317Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=h9IKpBRrzrI",
        "modified": {
            "$date": "2022-11-25T02:12:52.92Z"
        },
        "species": "02h00 23/11/2022"
    },
    {
        "_id": {
            "$oid": "637e21f37314986b3b944fe8"
        },
        "name": "Maroco - Croatia",
        "title": "Maroco 0 - 0 Croatia",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "maroco---croatia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e21f37314986b3b944fe8_background0.png?1669210650506",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group F",
        "type": "Football",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T13:36:51.539Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "city": "hochiminh",
        "keywords": "https://www.youtube.com/watch?v=pvpxqO7C6jE",
        "modified": {
            "$date": "2022-12-20T03:26:42.466Z"
        },
        "species": "17h00 23/11/2022"
    },
    {
        "_id": {
            "$oid": "637e38827314986b3b945120"
        },
        "name": "Đức - Nhật Bản",
        "title": "Đức 1 - 2 Nhật Bản",
        "keywords": "https://www.youtube.com/watch?v=A6SRB6seTSk",
        "city": "hochiminh",
        "address": "Khalifa International Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "đức---nhật-bản",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Đức chấp nữa trái",
        "details": "Germany 33' Japan 75' 83",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e38827314986b3b945120_background0.png?1669217509270"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group E",
        "type": "Hào, Sang, Đạt, Đăng",
        "grade": "Hùng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T15:13:06.879Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:23:04.168Z"
        },
        "species": "20h00 23/11/2022"
    },
    {
        "_id": {
            "$oid": "637e38f47314986b3b945129"
        },
        "name": "Tây Ban Nha - Costa Rica",
        "title": "Tây Ban Nha 7 - 0 Costa Rica",
        "keywords": "https://www.youtube.com/watch?v=qWilSWZXVAw",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "tây-ban-nha---costa-rica",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Costa Rica chấp Tây Ban Nha nữa trái",
        "details": "Dani Olmo 11' Marco Asensio 21' Ferran Torres 31' 54' Gavi 74 Carlos Soler 90' Álvaro Morata 90+2'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637e38f47314986b3b945129_background0.png?1669255856530"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Group E",
        "type": "Hào, Sang, Đạt",
        "grade": "Hùng, Nguyên, Đăng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-23T15:15:00.493Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:23:36.236Z"
        },
        "species": "23h00 23/11/2022"
    },
    {
        "_id": {
            "$oid": "637ed381cc60c212a0aba3ec"
        },
        "name": "Bỉ - Canada",
        "title": "Bỉ 1 - 0 Canada",
        "keywords": "https://www.youtube.com/watch?v=vFr-MS9-Gug",
        "city": "hochiminh",
        "address": "Ahmed bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bỉ---canada",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": null,
        "details": "Michy Batshuayi 44'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637ed381cc60c212a0aba3ec_background0.png?1669256054382"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng F",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-24T02:14:25.047Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-25T02:19:31.771Z"
        },
        "species": "02h00 24/11/2022"
    },
    {
        "_id": {
            "$oid": "637ed4c0cc60c212a0aba3fa"
        },
        "name": "Thụy Sĩ - Cameroon",
        "title": "Thụy Sĩ 1 - 0 Cameroon",
        "keywords": "https://www.youtube.com/watch?v=eO5lYcpRJvU",
        "city": "hochiminh",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "thụy-sĩ---cameroon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": null,
        "details": "Breel Embolo 48'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637ed4c0cc60c212a0aba3fa_background0.png?1669341435732"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng G",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-24T02:19:44.373Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-25T02:55:26.916Z"
        },
        "species": "17h00 24/11/2022"
    },
    {
        "_id": {
            "$oid": "637ed54bcc60c212a0aba403"
        },
        "name": "Uruguay - Hàn Quốc",
        "title": "Uruguay 0 - 0 Hàn Quốc",
        "keywords": "https://www.youtube.com/watch?v=HIujug2OhEE",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "uruguay---hàn-quốc",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Hàn Quốc chấp Uruguay 0.5 trái",
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637ed54bcc60c212a0aba403_background0.png?1669341504556"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng H",
        "species": "20h00 24/11/2022",
        "type": "Sang, Đăng, Đạt",
        "grade": "Hùng, Nguyên, Hào",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-24T02:22:03.807Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T05:24:18.094Z"
        }
    },
    {
        "_id": {
            "$oid": "637ed618cc60c212a0aba412"
        },
        "name": "Bồ Đào Nha - Ghana",
        "title": "Bồ Đào Nha 3 - 2 Ghana",
        "keywords": "https://www.youtube.com/watch?v=bSKAzou_gXM",
        "city": "hochiminh",
        "address": "Stadium 974 (Rass Abou Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bồ-đào-nha---ghana",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "Bồ Đào Nha 65' 78' 80' Ghana 73' 89'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637ed618cc60c212a0aba412_background0.png?1669341592489"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng H",
        "species": "23h00 24/11/2022",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-24T02:25:28.353Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-25T02:56:57.676Z"
        }
    },
    {
        "_id": {
            "$oid": "637ed64fcc60c212a0aba415"
        },
        "name": "Brasil - Serbia",
        "title": "Brasil 2 - 0 Serbia",
        "keywords": "https://www.youtube.com/watch?v=Xx6YaUIMuRQ",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "brasil---serbia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Serbia chấp Brasil 0.5 trái",
        "details": "Richarlison 62' 73'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/637ed64fcc60c212a0aba415_background0.png?1669341697091"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng G",
        "species": "02h00 25/11/2022",
        "type": "Hào, Sang, Đạt, Đăng",
        "grade": "Hùng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-24T02:26:23.893Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T05:25:54.872Z"
        }
    },
    {
        "_id": {
            "$oid": "638023119bd7f2d60d68322c"
        },
        "name": "Wales - Iran",
        "title": "Wales 0 - 2 Iran",
        "keywords": "https://www.youtube.com/watch?v=u_6jbUZaqqQ",
        "city": "hochiminh",
        "address": "Ahmed bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "wales---iran",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Iran chấp Wales nữa trái",
        "details": "Rouzbeh Cheshmi 90+8' Ramin Rezaeian 90+11'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638023119bd7f2d60d68322c_background0.png?1669385653567"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng B",
        "species": "17h00 25/11/2022",
        "type": "Nguyên, Sang, Đạt, Đăng",
        "grade": "Hùng, Hào",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T02:06:09.29Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-25T14:17:38.299Z"
        }
    },
    {
        "_id": {
            "$oid": "6380234c9bd7f2d60d68322f"
        },
        "name": "Qatar - Sénégal",
        "title": "Qatar 1 - 3 Sénégal",
        "keywords": "https://www.youtube.com/watch?v=OkcgRD-oS_w",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "qatar---sénégal",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "Qatar M. Muntari 78'  - Sénégal  B. Dia 41' F. Diedhiou 48' B. Dieng 84'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/6380234c9bd7f2d60d68322f_background0.png?1669423934261"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng A",
        "species": "20h00 25/11/2022",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T02:07:08.241Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T00:54:23.544Z"
        }
    },
    {
        "_id": {
            "$oid": "638023819bd7f2d60d683232"
        },
        "name": "Hà Lan - Ecuador",
        "title": "Hà Lan 1 - 1 Ecuador",
        "keywords": "https://www.youtube.com/watch?v=19r1oTlBhZI",
        "city": "hochiminh",
        "address": "Sân vận động Quốc tế Khalifa",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "hà-lan---ecuador",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ecuador chấp Hà Lan nữa trái",
        "details": "Hà Lan C. Gakpo 6'  - Ecuador E. Valencia 49'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638023819bd7f2d60d683232_background0.png?1669424131692"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng A",
        "species": "23h00 25/11/2022",
        "type": "Hào, Sang, Đạt, Đăng",
        "grade": "Hùng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T02:08:01.276Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T00:55:50.432Z"
        }
    },
    {
        "_id": {
            "$oid": "638023c29bd7f2d60d683235"
        },
        "name": "Anh - Mỹ",
        "title": "Anh 0 - 0 Mỹ",
        "keywords": "https://www.youtube.com/watch?v=p5lBw0u5C-Q",
        "city": "hochiminh",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "anh---mỹ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "đồng banh",
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638023c29bd7f2d60d683235_background0.png?1669424572179"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng B",
        "species": "02h00 26/11/2022",
        "type": "Hùng",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T02:09:06.695Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T23:36:16.52Z"
        }
    },
    {
        "_id": {
            "$oid": "63803c4c9bd7f2d60d6833d6"
        },
        "name": "Tunisia - Australia",
        "title": "Tunisia 0 - 1 Australia",
        "keywords": "https://www.youtube.com/watch?v=Bo-_7STQplY",
        "city": "hochiminh",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "tunisia---australia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Tunisia chấp Australia nữa trái",
        "details": "M. Duke 23'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803c4c9bd7f2d60d6833d6_background0.png?1669505841059"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng D",
        "species": "17h00 26/11/2022",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:53:48.822Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T23:38:53.497Z"
        }
    },
    {
        "_id": {
            "$oid": "63803c799bd7f2d60d6833d9"
        },
        "name": "Ba Lan - Saudi Arabia",
        "title": "Ba Lan 2 - 0 Saudi Arabia",
        "keywords": "https://www.youtube.com/watch?v=yVDdKknNcO8",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "ba-lan---saudi-arabia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Saudi Arabia chấp BaLan nữa trái",
        "details": "Piotr Zieliński 39' , Robert Lewandowski 82'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803c799bd7f2d60d6833d9_background0.png?1669506060656"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng C",
        "species": "20h00 26/11/2022",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:54:33.166Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T23:41:04.596Z"
        }
    },
    {
        "_id": {
            "$oid": "63803ca39bd7f2d60d6833dc"
        },
        "name": "Pháp - Đan Mạch",
        "title": "Pháp 2 - 1 Đan Mạch",
        "keywords": "https://www.youtube.com/watch?v=a-aIF1IQyNE",
        "city": "hochiminh",
        "address": "Stadium 974 (Rass Abou Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "pháp---đan-mạch",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pháp chấp Đan Mạch một trái rưỡi",
        "details": "Kylian Mbappé 61' 86'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803ca39bd7f2d60d6833dc_background0.png?1669506291787"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng D",
        "species": "23h00 26/11/2022",
        "type": "Hùng, Hào",
        "grade": "Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:55:15.592Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T23:45:23.968Z"
        }
    },
    {
        "_id": {
            "$oid": "63803cd49bd7f2d60d6833df"
        },
        "name": "Argentina - Mexico",
        "title": "Argentina 2 - 0 Mexico",
        "keywords": "https://www.youtube.com/watch?v=OQYdo0snkkU",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "argentina---mexico",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Argentina chấp Mexico 1 trái",
        "details": "Lionel Messi 64' , Enzo Fernández 87'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803cd49bd7f2d60d6833df_background0.png?1669506162565"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng C",
        "species": "02h00 27/11/2022",
        "type": "Hào",
        "grade": "Hùng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:56:04.029Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-26T23:42:59.543Z"
        }
    },
    {
        "_id": {
            "$oid": "63803ced9bd7f2d60d6833e2"
        },
        "name": "Nhật Bản - Costa Rica",
        "title": "Nhật Bản 0 - 1 Costa Rica",
        "keywords": "https://www.youtube.com/watch?v=gbqj0sQf1xU",
        "city": "hochiminh",
        "address": "Ahmed bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "nhật-bản---costa-rica",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Nhật Bản chấp Costa Rica nữa trái",
        "details": "K. Fuller 81'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803ced9bd7f2d60d6833e2_background0.jpeg?1669587633035"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng E",
        "species": "17h00 27/11/2022",
        "type": "Hào, Nguyên",
        "grade": "Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:56:29.52Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-28T01:53:05.541Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d039bd7f2d60d6833e5"
        },
        "name": "Bỉ - Maroc",
        "title": "Bỉ 0 - 2 Maroc",
        "keywords": "https://www.youtube.com/watch?v=BvKyqmAPgbo",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bỉ---maroc",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "Romain Saïss 73' Zakaria Aboukhlal 90+2'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d039bd7f2d60d6833e5_background0.jpeg?1669587555927"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng F",
        "species": "20h00 27/11/2022",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:56:51.04Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:24:39.241Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d159bd7f2d60d6833e8"
        },
        "name": "Croatia - Canada",
        "title": "Croatia 1 - 4 Canada",
        "keywords": "https://www.youtube.com/watch?v=7tNaMtJkNx4",
        "city": "hochiminh",
        "address": "Khalifa International Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "croatia---canada",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "Croatia 36' 70' 44' 90+4' , Canada 2'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d159bd7f2d60d6833e8_background0.jpeg?1669587720412"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng F",
        "species": "23h00 27/11/2022",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:57:09.628Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-28T01:51:34.654Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d2d9bd7f2d60d6833eb"
        },
        "name": "Tây Ban Nha - Đức",
        "title": "Tây Ban Nha 1 - 1 Đức",
        "keywords": "https://www.youtube.com/watch?v=1qFqBS3uV2I",
        "city": "hochiminh",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "tây-ban-nha---đức",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Đức chấp Tây Ban Nha nữa trái",
        "details": "Álvaro Morata 62' , Niclas Füllkrug 83'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d2d9bd7f2d60d6833eb_background0.jpeg?1669587818484"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng E",
        "species": "02h00 28/11/2022",
        "type": "Hào",
        "grade": "Hùng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:57:33.099Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-28T01:50:00.187Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d409bd7f2d60d6833ee"
        },
        "name": "Cameroon - Serbia",
        "title": "Cameroon 3 - 3 Serbia",
        "keywords": "https://www.youtube.com/watch?v=BdOb1hG5txk",
        "city": "hochiminh",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "cameroon---serbia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Cameroon chấp Serbia 1 trái",
        "details": "Cameroon 29' 63' 66' - Serbia 45+1' 45+3' 53'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d409bd7f2d60d6833ee_background0.png?1669643441916"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng G",
        "species": "17h00 28/11/2022",
        "type": "",
        "grade": "Đăng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:57:52.856Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-28T13:51:17.229Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d549bd7f2d60d6833f1"
        },
        "name": "Hàn Quốc - Ghana",
        "title": "Hàn Quốc 2 - 3 Ghana",
        "keywords": "https://www.youtube.com/watch?v=r8LVR0N94JQ",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "hàn-quốc---ghana",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Hàn Quốc chấp Ghana nữa trái",
        "details": "Hàn Quốc 58' 61' - Ghana 24' 34' 68'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d549bd7f2d60d6833f1_background0.png?1669648129416"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng H",
        "species": "20h00 28/11/2022",
        "type": "Hào, Hùng",
        "grade": "Đăng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:58:12.947Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-28T15:10:55.097Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d669bd7f2d60d6833f4"
        },
        "name": "Brasil - Thụy Sĩ",
        "title": "Brasil 1 - 0 Thụy Sĩ",
        "keywords": "https://www.youtube.com/watch?v=tR2kj9MLVkU",
        "city": "hochiminh",
        "address": "Stadium 974 - Ras Abu Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "brasil---thụy-sĩ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Brazil chấp Thụy Sĩ nữa trái",
        "details": "Casemiro 83'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d669bd7f2d60d6833f4_background0.png?1669684146963"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng G",
        "species": "23h00 28/11/2022",
        "type": "Đăng, Đạt, Sang, Nguyên",
        "grade": "Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:58:30.365Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:27:40.086Z"
        }
    },
    {
        "_id": {
            "$oid": "63803d7b9bd7f2d60d6833f7"
        },
        "name": "Bồ Đào Nha - Uruguay",
        "title": "Bồ Đào Nha 2 - 0 Uruguay",
        "keywords": "https://www.youtube.com/watch?v=IBud6w-JWXs",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bồ-đào-nha---uruguay",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Uruguay chấp Bồ Đào Nha nữa trái",
        "details": "Bruno Fernandes 54' 90+3'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803d7b9bd7f2d60d6833f7_background0.png?1669684273360"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng H",
        "species": "02h00 29/11/2022",
        "type": "Đăng, Sang, Đạt, Hào",
        "grade": "Nguyên, Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:58:51.437Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-29T01:11:52.349Z"
        }
    },
    {
        "_id": {
            "$oid": "63803da39bd7f2d60d6833fa"
        },
        "name": "Hà Lan - Qatar",
        "title": "Hà Lan 2 - 0 Qatar",
        "keywords": "https://www.youtube.com/watch?v=YM_epVo7Qho",
        "city": "hochiminh",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "hà-lan---qatar",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Hà Lan chấp Qatar 1 trái",
        "details": "Cody Gakpo 26' , Frenkie de Jong 49'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803da39bd7f2d60d6833fa_background0.png?1669772524024"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng A",
        "species": "22h00 29/11/2022",
        "type": "Đạt, Sang, Hào",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:59:31.541Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-30T01:42:52.021Z"
        }
    },
    {
        "_id": {
            "$oid": "63803db29bd7f2d60d6833fd"
        },
        "name": "Ecuador - Sénégal",
        "title": "Ecuador 1 - 2 Sénégal",
        "keywords": "https://www.youtube.com/watch?v=L6D2LhgJK7g",
        "city": "hochiminh",
        "address": "Khalifa International Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "ecuador---sénégal",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ecuador chấp Senegal nữa trái",
        "details": "Ecuador 67' - Senegal 44' 70'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803db29bd7f2d60d6833fd_background0.png?1669772441663"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng A",
        "species": "22h00 29/11/2022",
        "type": "Đạt, Hào, Hùng",
        "grade": "Sang",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T03:59:46.239Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:15:34.558Z"
        }
    },
    {
        "_id": {
            "$oid": "63803dcd9bd7f2d60d683400"
        },
        "name": "Iran - Mỹ",
        "title": "Iran 0 - 1 Mỹ",
        "keywords": "https://www.youtube.com/watch?v=_EBLBHZz9p0",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "iran---mỹ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Iran chấp Mỹ nữa trái",
        "details": "Christian Pulisic 38'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803dcd9bd7f2d60d683400_background0.png?1669772366658"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng B",
        "species": "02h00 30/11/2022",
        "type": "Hùng, Hào",
        "grade": "Đạt, Đăng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:00:13.625Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-30T01:40:19.83Z"
        }
    },
    {
        "_id": {
            "$oid": "63803dda9bd7f2d60d683403"
        },
        "name": "Wales - Anh",
        "title": "Wales 0 - 3 Anh",
        "keywords": "https://www.youtube.com/watch?v=nlmMMFVc7LA",
        "city": "hochiminh",
        "address": "Ahmed bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "wales---anh",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Xứ Wales chấp Anh nữa trái",
        "details": "Marcus Rashford 50' 68' , Phil Foden 51'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803dda9bd7f2d60d683403_background0.png?1669772272472"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng B",
        "species": "02h00 30/11/2022",
        "type": "Hùng",
        "grade": "Đăng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:00:26.43Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-11-30T01:39:14.356Z"
        }
    },
    {
        "_id": {
            "$oid": "63803def9bd7f2d60d683406"
        },
        "name": "Đan Mạch - Australia",
        "title": "Đan Mạch 0 - 1 Australia",
        "keywords": "https://www.youtube.com/watch?v=HDiujpGds_g",
        "city": "hochiminh",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "đan-mạch---australia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Đan Mạch chấp Australia nữa trái",
        "details": "Mathew Leckie 60'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803def9bd7f2d60d683406_background0.png?1669857158881"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng D",
        "species": "22h00 30/11/2022",
        "type": "Sang, Hào",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:00:47.421Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-01T01:13:37.354Z"
        }
    },
    {
        "_id": {
            "$oid": "63803dfe9bd7f2d60d683409"
        },
        "name": "Pháp - Tunisia",
        "title": "Pháp 0 - 1 Tunisia",
        "keywords": "https://www.youtube.com/watch?v=LFxf9rbZh6E",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "pháp---tunisia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pháp Chấp Tunisia 1 trái",
        "details": "Wahbi Khazri 58'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803dfe9bd7f2d60d683409_background0.png?1669856928520"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng D",
        "species": "22h00 30/11/2022",
        "type": "Hào, Sang",
        "grade": "Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:01:02.292Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-01T01:09:36.275Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e1b9bd7f2d60d68340c"
        },
        "name": "Argentina - Ba Lan",
        "title": "Argentina 2 - 0 Ba Lan",
        "keywords": "https://www.youtube.com/watch?v=4D4gdH50Ndo",
        "city": "hochiminh",
        "address": "Stadium 974 - Ras Abu Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "argentina---ba-lan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Argentina chấp Ba Lan 1 trái",
        "details": "Alexis Mac Allister 46' , Julián Álvarez 67'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e1b9bd7f2d60d68340c_background0.png?1669857443156"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng C",
        "species": "02h00 01/12/2022",
        "type": "Hào",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:01:31.497Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-01T01:18:09.118Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e259bd7f2d60d68340f"
        },
        "name": "Saudi Arabia - Mexico",
        "title": "Saudi Arabia 1 - 2 Mexico",
        "keywords": "https://www.youtube.com/watch?v=UvOCqTJSPf0",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "saudi-arabia---mexico",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Saudi Arabia chấp Mexico nữa trái",
        "details": "Saudi Arabia 90+5' , Mexico 47' 52'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e259bd7f2d60d68340f_background0.png?1669857717009"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng C",
        "species": "02h00 01/12/2022",
        "type": "Hào, Nguyên",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:01:41.403Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-01T01:23:06.688Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e399bd7f2d60d683412"
        },
        "name": "Croatia - Bỉ",
        "title": "Croatia 0 - 0 Bỉ",
        "keywords": "https://www.youtube.com/watch?v=HTCDqPb3bOw",
        "city": "hochiminh",
        "address": "Ahmad bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "croatia---bỉ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Croatia chấp Bỉ 1 trái",
        "details": "Croatia chấp Bỉ 1 trái",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e399bd7f2d60d683412_background0.png?1669944955523"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng F",
        "species": "22h00 01/12/2022",
        "type": "Nguyên",
        "grade": "Sang, Đạt, Đăng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:02:01.541Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-02T01:36:46.227Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e459bd7f2d60d683415"
        },
        "name": "Maroc - Canada",
        "title": "Maroc 2 - 1 Canada",
        "keywords": "https://www.youtube.com/watch?v=g0zCmiZ8hb0",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "maroc---canada",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Ma-rốc chấp Canada nữa trái",
        "details": "Ma-rốc 4' 23' , Canada 40'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e459bd7f2d60d683415_background0.png?1669944804787"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng F",
        "species": "22h00 01/12/2022",
        "type": "Sang, Hùng",
        "grade": "Nguyên, Đăng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:02:13.793Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:24:31.863Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e659bd7f2d60d683418"
        },
        "name": "Tây Ban Nha - Nhật Bản",
        "title": "Tây Ban Nha 1 - 2 Nhật",
        "keywords": "https://www.youtube.com/watch?v=olcXihNQPu0",
        "city": "hochiminh",
        "address": "Sân vận động Quốc tế Khalifa",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "tây-ban-nha---nhật-bản",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Tây Ban Nha chấp Nhật Bản 1 trái rưỡi",
        "details": "Tây Ban Nha 11' , Nhật 48' 51'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e659bd7f2d60d683418_background0.png?1669944533100"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng E",
        "species": "02h00 02/12/2022",
        "type": "Đạt, Đăng",
        "grade": "Hào, Nguyên, Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:02:45.633Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-02T01:32:02.185Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e719bd7f2d60d68341b"
        },
        "name": "Đức - Costa Rica",
        "title": "Đức 4 -2  Costa Rica",
        "keywords": "https://www.youtube.com/watch?v=b8AN49o2gmU",
        "city": "hochiminh",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "đức---costa-rica",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Đức chấp Costa Rica 1 trái",
        "details": "Đức 10' 73' 85' 89' , Costa Rica 58' 70'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e719bd7f2d60d68341b_background0.png?1669944486425"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng E",
        "species": "02h00 02/12/2022",
        "type": "Nguyên, Đăng, Đạt",
        "grade": "Hào",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:02:57.106Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-02T01:28:43.259Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e7e9bd7f2d60d68341e"
        },
        "name": "Uruguay - Ghana",
        "title": "Uruguay 2 - 0 Ghana",
        "keywords": "https://www.youtube.com/watch?v=onKcevZUgTI",
        "city": "hochiminh",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "uruguay---ghana",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Uruguay chấp Ghana nữa trái",
        "details": "Giorgian de Arrascaeta 26' 32'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e7e9bd7f2d60d68341e_background0.png?1670038110411"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng H",
        "species": "22h00 02/12/2022",
        "type": "Hùng",
        "grade": "Sang",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:03:10.391Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-03T03:28:43.837Z"
        }
    },
    {
        "_id": {
            "$oid": "63803e899bd7f2d60d683421"
        },
        "name": "Bồ Đào Nha - Hàn Quốc",
        "title": "Bồ Đào Nha 1 - 2 Hàn Quốc",
        "keywords": "https://www.youtube.com/watch?v=qaBp222Ssio",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bồ-đào-nha---hàn-quốc",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Bồ Đào Nha chấp Hàn Quốc 1 trái",
        "details": "Bồ Đào Nha 5' ,  Hàn Quốc 27' 90+1'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803e899bd7f2d60d683421_background0.png?1670037934777"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng H",
        "species": "22h00 02/12/2022",
        "type": "Hùng, Đăng",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:03:21.855Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-03T03:26:18.038Z"
        }
    },
    {
        "_id": {
            "$oid": "63803ea19bd7f2d60d683424"
        },
        "name": "Serbia - Thụy Sĩ",
        "title": "Serbia 2 - 3 Thụy Sĩ",
        "keywords": "https://www.youtube.com/watch?v=kVSYZpFupTQ",
        "city": "hochiminh",
        "address": "Stadium 974 - Ras Abu Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "serbia---thụy-sĩ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Serbia chấp Thụy Sĩ nữa trái",
        "details": "Serbia 26' 35' , Thụy Sĩ 20' 44' 48'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803ea19bd7f2d60d683424_background0.png?1670037874110"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng G",
        "species": "02h00 03/12/2022",
        "type": "",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:03:45.212Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-03T03:25:00.675Z"
        }
    },
    {
        "_id": {
            "$oid": "63803eaf9bd7f2d60d683427"
        },
        "name": "Brasil - Cameroon",
        "title": "Brasil 0 - 1 Cameroon",
        "keywords": "https://www.youtube.com/watch?v=9G-bouyEx98",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "brasil---cameroon",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Brazil chấp Cameroon 1 trái",
        "details": "Vincent Aboubakar 90+x'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803eaf9bd7f2d60d683427_background0.png?1670035294951"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bảng G",
        "species": "02h00 03/12/2022",
        "type": "Sang, Hào, Đăng",
        "grade": "Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:03:59.847Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:28:10.821Z"
        }
    },
    {
        "_id": {
            "$oid": "63803edd9bd7f2d60d68342a"
        },
        "name": "Hà Lan - Mỹ",
        "title": "Hà Lan 3 - 1 Mỹ",
        "keywords": "https://www.youtube.com/watch?v=DtdjBGuMYcg",
        "city": "hochiminh",
        "address": "Sân vận động Quốc tế Khalifa",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "hà-lan---mỹ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Hà Lan chấp Mỹ nữa trái trong 90'",
        "details": "Hà Lan 10' 45+1' 81' , 1 Mỹ 76'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803edd9bd7f2d60d68342a_background0.png?1670131923757"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "22h00 03/12/2022",
        "type": "Mehdi, Hào",
        "grade": "Hùng",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:04:45.627Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-04T05:32:40.128Z"
        }
    },
    {
        "_id": {
            "$oid": "63803ef99bd7f2d60d68342d"
        },
        "name": "Argentina - Australia",
        "title": "Argentina 2 - 1 Australia",
        "keywords": "https://www.youtube.com/watch?v=h754tEj5tNE",
        "city": "hochiminh",
        "address": "Ahmad bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "argentina---australia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Argentina chấp Australia 1 trái rưỡi trong 90'",
        "details": "Argentina 35' 57' , Australia 77'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803ef99bd7f2d60d68342d_background0.jpeg?1670119452048"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "02h00 04/12/2022",
        "type": "Hùng, Hào",
        "grade": "Mehdi",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:05:13.693Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-04T05:31:23.459Z"
        }
    },
    {
        "_id": {
            "$oid": "63803f0f9bd7f2d60d683430"
        },
        "name": "Pháp - Ba Lan",
        "title": "Pháp 3 - 1 Ba Lan",
        "keywords": "https://www.youtube.com/watch?v=NvNwXrNtHZo",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "pháp---ba-lan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pháp chấp Ba lan 1 trái rưỡi trong 90'",
        "details": "Pháp 44' 74' 90+1' , Ba Lan 90+9'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803f0f9bd7f2d60d683430_background0.png?1670202691899"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "22h00 04/12/2022",
        "type": "Mehdi, Hùng",
        "grade": "Hào, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:05:35.827Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-05T01:12:45.838Z"
        }
    },
    {
        "_id": {
            "$oid": "63803f2b9bd7f2d60d683433"
        },
        "name": "Anh - Sénégal",
        "title": "Anh 3 - 0 Sénégal",
        "keywords": "https://www.youtube.com/watch?v=xbWuxSJXRy4",
        "city": "hochiminh",
        "address": "Ahmed bin Ali Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "anh---sénégal",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Anh chấp Sénégal 1 trái trong 90'",
        "details": "Jordan Henderson 38' , Harry Kane 45+3' , Bukayo Saka 57'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803f2b9bd7f2d60d683433_background0.png?1670202779785"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "02h00 05/12/2022",
        "type": "Mehdi, Nguyên",
        "grade": "Hùng, Hào",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:06:03.748Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-05T01:14:04.216Z"
        }
    },
    {
        "_id": {
            "$oid": "63803f3c9bd7f2d60d683436"
        },
        "name": "Croatia - Nhật Bản",
        "title": "Croatia 1 (3) - 1 Nhật Bản",
        "keywords": "https://www.youtube.com/watch?v=gqochlOFIQ8",
        "city": "hochiminh",
        "address": "Al Janoub Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "croatia---nhật-bản",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Croatia chấp nhật 0.5 trong 90'",
        "details": "Ivan Perišić 55 , Maeda Daizen 43', Phạt luân lưu 3 - 1",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803f3c9bd7f2d60d683436_background0.png?1670288982057"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "22h00 05/12/2022",
        "type": "Sang",
        "grade": "Hùng, Hào, Nguyên, Mehdi",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:06:20.933Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-06T01:10:54.081Z"
        }
    },
    {
        "_id": {
            "$oid": "63803f569bd7f2d60d683439"
        },
        "name": "Brasil - Hàn Quốc",
        "title": "Brasil 4 - 1 Hàn Quốc",
        "keywords": "https://www.youtube.com/watch?v=uz9ReDATCG4",
        "city": "hochiminh",
        "address": "Stadium 974 - Ras Abu Aboud",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "brasil---hàn-quốc",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Brasil chấp Hàn Quốc 1.5 trong 90'",
        "details": "Brasil 7' 13' 29' 36' - 1 Hàn Quốc 76'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803f569bd7f2d60d683439_background0.png?1670289054928"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "02h00 06/12/2022",
        "type": "Hào, Sang, Mehdi",
        "grade": "Hùng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:06:46.369Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-06T01:12:01.069Z"
        }
    },
    {
        "_id": {
            "$oid": "63803f639bd7f2d60d68343c"
        },
        "name": "Maroc - Tây Ban Nha",
        "title": "Maroc 0(3) - 0 Tây Ban Nha",
        "keywords": "https://www.youtube.com/watch?v=pFPpPSO6ITo",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "maroc---tây-ban-nha",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Tây Ban Nha chấp Ma Rốc 1 trong 90'",
        "details": "Ma Rốc 3 - 0 Tây Ban Nha phạt luân lưu",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803f639bd7f2d60d68343c_background0.png?1670376465820"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "22h00 06/12/2022",
        "type": "Mehdi",
        "grade": "Hùng, Hào, Sang",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:06:59.685Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T01:29:00.414Z"
        }
    },
    {
        "_id": {
            "$oid": "63803f799bd7f2d60d68343f"
        },
        "name": "Bồ Đào Nha - Thụy Sĩ",
        "title": "Bồ Đào Nha 6 - 1 Thụy Sĩ",
        "keywords": "https://www.youtube.com/watch?v=f_i5J4ypjF0",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bồ-đào-nha---thụy-sĩ",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Bồ Đào Nha chấp Thụy Sĩ 0.5 trong 90'",
        "details": "Bồ Đào Nha 17' 51' 67' 33' 55' 90+2' , Thụy Sĩ 58'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803f799bd7f2d60d68343f_background0.png?1670376765008"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "vòng 1/8",
        "species": "02h00 07/12/2022",
        "type": "Hùng, Hào, Mehdi, Sang",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:07:21.617Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T01:33:55.374Z"
        }
    },
    {
        "_id": {
            "$oid": "63803fef9bd7f2d60d683442"
        },
        "name": "Brasil - Croatia",
        "title": "Brasil 1 (2) - (4) 1 Croatia",
        "keywords": "https://www.youtube.com/watch?v=Aq-4_6qGzRk",
        "city": "hochiminh",
        "address": "Education City Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "brasil---croatia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Brasil chấp Croatia 1 trái trong 90'",
        "details": "Neymar 105+1' , Bruno Petković 117' (Penalties 2 - 4)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803fef9bd7f2d60d683442_background0.png?1670637128683"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Tứ kết",
        "species": "22h00 09/12/2022",
        "type": "Hào, Hùng, Đăng, Đạt, Sang",
        "grade": "Nguyên, Mehdi",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:09:19.167Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-10T01:53:56.423Z"
        }
    },
    {
        "_id": {
            "$oid": "63803ffc9bd7f2d60d683445"
        },
        "name": "Argentina - Hà Lan",
        "title": "Argentina 2 (4) - (3) 2 Hà Lan",
        "keywords": "https://www.youtube.com/watch?v=786rNxVoQtU",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "argentina---hà-lan",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Argentina chấp Hà Lan 0.5 trái trong 90'",
        "details": "Argentina 35' 73' , Hà Lan 83' 90+11' (Penalties 4-3)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/63803ffc9bd7f2d60d683445_background0.png?1670637396524"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Tứ kết",
        "species": "02h00 10/12/2022",
        "type": "Hào, Hùng, Đạt, Sang, Mehdi",
        "grade": "Đăng, Nguyên",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:09:32.516Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-10T01:58:02.373Z"
        }
    },
    {
        "_id": {
            "$oid": "638040059bd7f2d60d683448"
        },
        "name": "Bồ Đào Nha - Maroc",
        "title": "Bồ Đào Nha 0 - 1 Maroc",
        "keywords": "https://www.youtube.com/watch?v=CHS5Kw6p37I",
        "city": "hochiminh",
        "address": "Al Thumama Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "bồ-đào-nha---maroc",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Bồ Đào Nha chấp Ma Rốc 0.5 trong 120'",
        "details": "Youssef En-Nesyri 42'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638040059bd7f2d60d683448_background0.png?1670810326168"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Tứ kết",
        "species": "22h00 10/12/2022",
        "type": "Hùng",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:09:41.282Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-12T01:59:53.375Z"
        }
    },
    {
        "_id": {
            "$oid": "638040119bd7f2d60d68344b"
        },
        "name": "Pháp - Anh",
        "title": "Pháp 2 - 1 Anh",
        "keywords": "https://www.youtube.com/watch?v=8wUhhmyUDyo",
        "city": "hochiminh",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "pháp---anh",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pháp chấp Anh 0.5 trong 120'",
        "details": "Pháp 17' 78' ,  Anh 54'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638040119bd7f2d60d68344b_background0.png?1670810234157"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Tứ kết",
        "species": "02h00 11/12/2022",
        "type": "Hùng, Mehdi",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:09:53.194Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-12T01:58:28.522Z"
        }
    },
    {
        "_id": {
            "$oid": "638040289bd7f2d60d68344e"
        },
        "name": "Argentina - Croatia",
        "title": "Argentina 3 - 0 Croatia",
        "keywords": "https://www.youtube.com/watch?v=KbbJSPW1OCs",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "argentina---croatia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Argentina chấp Croatia 0.5 trong 120'",
        "details": "Lionel Messi 34' , Julián Álvarez 39' 69'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638040289bd7f2d60d68344e_background0.png?1670981500212"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bán kết",
        "species": "02h00 14/12/2022",
        "type": "Hùng, Mehdi",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:10:16.268Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-14T01:32:52.261Z"
        }
    },
    {
        "_id": {
            "$oid": "638040319bd7f2d60d683451"
        },
        "name": "Pháp - Maroc",
        "title": "Pháp 2 - 0 Maroc",
        "keywords": "https://www.youtube.com/watch?v=x6THDpeyiE4",
        "city": "hochiminh",
        "address": "Al Bayt Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "pháp---maroc",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pháp chấp Maroc 1 trong 120'",
        "details": "Theo Hernández 5' , Randal Kolo Muani 79'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638040319bd7f2d60d683451_background0.png?1671505911950"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Bán kết",
        "species": "02h00 15/12/2022",
        "type": "Hùng, Mehdi",
        "grade": "",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:10:25.865Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:13:04.096Z"
        }
    },
    {
        "_id": {
            "$oid": "6380405c9bd7f2d60d683454"
        },
        "name": "Maroc - Croatia",
        "title": "Maroc 1 - 2 Croatia",
        "keywords": "https://www.youtube.com/watch?v=xcpmS_czg-Q",
        "city": "hochiminh",
        "address": "Khalifa International Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "maroc---croatia",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Maroc chấp Croatia 0.5 trong 120'",
        "details": "Maroc  9' , Croatia 7'  42'",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/6380405c9bd7f2d60d683454_background0.png?1671505869900"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Hạng 3 4",
        "species": "22h00 17/12/2022",
        "type": "",
        "grade": "Hùng, Hào, Nguyên, Đạt",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:11:08.824Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-20T03:11:59.863Z"
        }
    },
    {
        "_id": {
            "$oid": "638040729bd7f2d60d683457"
        },
        "name": "Pháp - Argentina",
        "title": "Pháp 3(2) - 3(4) Argentina",
        "keywords": "https://www.youtube.com/watch?v=tpPmn2ZuOV8",
        "city": "hochiminh",
        "address": "Lusail Stadium",
        "category": "worldcup2022",
        "subCategory": "match",
        "slug": "pháp---argentina",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "Pháp chấp Argentina 1.5 trong 120'\n\n[{\"id\":1,\"name\":\"Hùng\",\"predict\":\"Pháp - Nhật Bản\"},{\"id\":2,\"name\":\"Hào\",\"predict\":\"Basil - Bồ Đào Nha\"},{\"id\":3,\"name\":\"Nguyên\",\"predict\":\"Pháp - Argentina\"},{\"id\":4,\"name\":\"Sang\",\"predict\":\"Brasil - Pháp\"},{\"id\":5,\"name\":\"Đăng\",\"predict\":\"Brasil - Bồ Đào Nha\"},{\"id\":6,\"name\":\"Đạt\",\"predict\":\"Brasil - Pháp\"},{\"id\":7,\"name\":\"Mehdi\",\"predict\":\"Argentina,France\"}]",
        "details": "Pháp 3(2) 80' 81' 118' - 3(4) Argentina 23' 108' 36' (Penalties 2:4)",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638040729bd7f2d60d683457_background0.png?1671417179770"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Chung kết",
        "species": "02h00 18/12/2022",
        "type": "Hùng, Sang",
        "grade": "Hào, Nguyên, Đạt",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-11-25T04:11:30.736Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-19T02:36:49.635Z"
        }
    },
    {
        "_id": {
            "$oid": "638ec5c44ea55597142e601b"
        },
        "name": "Andy",
        "title": "Andy",
        "keywords": "",
        "city": "hochiminh",
        "address": "",
        "category": "andy",
        "subCategory": "other",
        "slug": "andy",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": null,
        "details": "[{\"icon\":\"shopping-bag\",\"title\":\"8kg\"},{\"icon\":\"bed\",\"title\":\"80cm\"},{\"icon\":\"shopping-bag\",\"title\":\"4 Răng\"},{\"icon\":\"shopping-bag\",\"title\":\"Nói nhiều\"},{\"icon\":\"shopping-bag\",\"title\":\"Tự ngủ\"},{\"icon\":\"shopping-bag\",\"title\":\"Ghét bị sờ lên mặt\"},{\"icon\":\"shopping-bag\",\"title\":\"Thích nước\"},{\"icon\":\"shopping-bag\",\"title\":\"Thích hóng\"},{\"icon\":\"shopping-bag\",\"title\":\"Thích ăn vặt\"}]",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638ec5c44ea55597142e601b_background0.jpeg?1670301511888"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": null,
        "type": null,
        "grade": null,
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-12-06T04:32:04.063Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Closed",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-06T04:43:51.41Z"
        }
    },
    {
        "_id": {
            "$oid": "638eca4c4ea55597142e6050"
        },
        "name": "andy 1",
        "title": "andy 1",
        "keywords": "",
        "city": "hochiminh",
        "address": "",
        "category": "andy",
        "subCategory": "other",
        "slug": "andy-1",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": null,
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638eca4c4ea55597142e6050_background0.jpeg?1670302378572"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": null,
        "type": null,
        "grade": null,
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-12-06T04:51:24.573Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Pending",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-06T04:53:39.86Z"
        }
    },
    {
        "_id": {
            "$oid": "638ecae34ea55597142e6064"
        },
        "name": "andy 2",
        "title": "andy 2",
        "keywords": "",
        "city": "hochiminh",
        "address": "",
        "category": "andy",
        "subCategory": "other",
        "slug": "andy-2",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": null,
        "details": "",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "https://mylife-api.herokuapp.com/api/files/image/638ecae34ea55597142e6064_background0.jpeg?1670302406441"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": null,
        "type": null,
        "grade": null,
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-12-06T04:53:55.154Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "Pending",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "modified": {
            "$date": "2022-12-06T04:54:06.284Z"
        }
    },
    {
        "_id": {
            "$oid": "639033dca456a36f09854782"
        },
        "name": "Bò Tơ Quán Mộc",
        "title": "Bò Tơ Quán Mộc",
        "ApiKey": null,
        "FacebookURL": null,
        "TwitterURL": null,
        "LinkedinURL": null,
        "InstagramURL": null,
        "mapLongitude": null,
        "mapLatitude": null,
        "city": "hochiminh",
        "address": " 43-45 Nguyễn Thị Thập, P.Tân Hưng, Khu dân cư Him Lam, Quận 7, TP HCM ",
        "email": "cskh1.aladdin@gmail.com",
        "phone": "0858453388",
        "website": "https://botoquanmoc.com",
        "category": "realestate",
        "subCategory": "restaurants",
        "slug": "bò-tơ-quán-mộc",
        "rate": 5,
        "price": null,
        "quantity": 1,
        "description": "More Information",
        "details": null,
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "videoYoutube": null,
        "videoVimeo": null,
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "promoVideoYoutube": null,
        "promoVideoVimeo": null,
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-12-07T06:34:04.566Z"
        },
        "createdBy": "admin",
        "modifiedBy": "Hung Nguyen",
        "status": "active",
        "active": true,
        "FreeWiFi": null,
        "Parking": null,
        "FitnessCenter": null,
        "NonSmokingRooms": null,
        "AirportShuttle": null,
        "AirConditioning": null,
        "Events": null,
        "FriendlyWorkspace": null,
        "SidebarWidgetsBookingForm": null,
        "SidebarWidgetsPriceRange": null,
        "SidebarWidgetsInstagram": null,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T06:52:18.497Z"
        }
    },
    {
        "_id": {
            "$oid": "63903833a456a36f0985479b"
        },
        "name": "California Fitness & Yoga",
        "title": "California Fitness & Yoga",
        "ApiKey": null,
        "FacebookURL": null,
        "TwitterURL": null,
        "LinkedinURL": null,
        "InstagramURL": null,
        "mapLongitude": null,
        "mapLatitude": null,
        "city": "hochiminh",
        "address": " Số 126 Hùng Vương, P.12, Q.5, Tp. Hồ Chí Minh, Việt Nam",
        "email": null,
        "phone": " (028) 7109 1899 ",
        "website": null,
        "category": "realestate",
        "subCategory": "fitness",
        "slug": "california-fitness-&-yoga",
        "rate": 5,
        "price": null,
        "quantity": 1,
        "description": "More Information",
        "details": null,
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "videoYoutube": null,
        "videoVimeo": null,
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "promoVideoYoutube": null,
        "promoVideoVimeo": null,
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-12-07T06:52:35.523Z"
        },
        "createdBy": "admin",
        "modifiedBy": "admin",
        "status": "pending",
        "active": true,
        "FreeWiFi": null,
        "Parking": null,
        "FitnessCenter": null,
        "NonSmokingRooms": null,
        "AirportShuttle": null,
        "AirConditioning": null,
        "Events": null,
        "FriendlyWorkspace": null,
        "SidebarWidgetsBookingForm": null,
        "SidebarWidgetsPriceRange": null,
        "SidebarWidgetsInstagram": null,
        "__v": 0,
        "modified": {
            "$date": "2022-12-07T07:05:25.319Z"
        }
    },
    {
        "_id": {
            "$oid": "63903bf307a0bf9bc9f93397"
        },
        "name": "Adidas",
        "title": "Adidas",
        "ApiKey": null,
        "FacebookURL": null,
        "TwitterURL": null,
        "LinkedinURL": null,
        "InstagramURL": null,
        "mapLongitude": null,
        "mapLatitude": null,
        "city": "hochiminh",
        "address": "",
        "email": null,
        "phone": null,
        "website": null,
        "category": "realestate",
        "subCategory": "shops",
        "slug": "adidas",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "",
        "details": "More Information",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "videoYoutube": null,
        "videoVimeo": null,
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "promoVideoYoutube": null,
        "promoVideoVimeo": null,
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "created": {
            "$date": "2022-12-07T07:08:35.233Z"
        },
        "createdBy": "hung",
        "modifiedBy": "Hung Nguyen",
        "status": "pending",
        "active": true,
        "FreeWiFi": null,
        "Parking": null,
        "FitnessCenter": null,
        "NonSmokingRooms": null,
        "AirportShuttle": null,
        "AirConditioning": null,
        "Events": null,
        "FriendlyWorkspace": null,
        "SidebarWidgetsBookingForm": null,
        "SidebarWidgetsPriceRange": null,
        "SidebarWidgetsInstagram": null,
        "__v": 0,
        "modified": {
            "$date": "2022-12-19T03:50:30.878Z"
        },
        "keywords": "",
        "userId": {
            "$oid": "639976fce54d2783d1c5f2bc"
        }
    },
    {
        "_id": {
            "$oid": "639154a2eb289a3b99fabecb"
        },
        "name": "R871373869_1670468732127",
        "title": "California Fitness & Yoga",
        "email": "hung@mgial.com",
        "website": "456",
        "category": "reviews",
        "subCategory": "other",
        "slug": "r871373869_1670468732127",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "TEST",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "customerName": "Hung",
        "paymentState": "Paid using Paypal",
        "created": {
            "$date": "2022-12-08T03:06:10.409Z"
        },
        "createdBy": "Hung",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "639154adeb289a3b99fabece"
        },
        "name": "R617012104_1670468743462",
        "title": "California Fitness & Yoga",
        "email": "hung@mgial.com",
        "website": "456",
        "category": "reviews",
        "subCategory": "other",
        "slug": "r617012104_1670468743462",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "TEST",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "customerName": "Hung",
        "paymentState": "Paid using Paypal",
        "created": {
            "$date": "2022-12-08T03:06:21.774Z"
        },
        "createdBy": "Hung",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "639156c7eb289a3b99fabf0e"
        },
        "name": "R972607014_1670469281582",
        "title": "California Fitness & Yoga",
        "email": "hung@mgial.com",
        "website": "",
        "category": "reviews",
        "subCategory": "other",
        "slug": "r972607014_1670469281582",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "More Information",
        "details": "test3",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "customerName": "Hung",
        "paymentState": "Paid using Paypal",
        "created": {
            "$date": "2022-12-08T03:15:19.893Z"
        },
        "createdBy": "Hung",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63940ab5c8ba782dd4ae0e85"
        },
        "name": "R897781428_1670646454102",
        "title": "Adidas",
        "email": "test",
        "website": "",
        "category": "reviews",
        "subCategory": "other",
        "slug": "r897781428_1670646454102",
        "rate": 5,
        "price": 1,
        "quantity": 1,
        "description": "[\n   {\"createdBy\": \"Hung\", \"created\":\"Dec 10, 2022, 11:27:34 AM\", \"details\": \"OK!!\", \"title\": \"R897781428_1670646454102\", \"name\":\"R897781111_16706464542323\", \"description\": [], \"customerName\": \"Hung\", \"email\": \"guest@gmail.com\"}\n]",
        "details": "???",
        "images": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "thumbImage": [
            "/assets/images/products/clothes/1.png",
            "/assets/images/products/clothes/2.png"
        ],
        "backgroundImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "carouselImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "galleryThumbnails": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "sliderImages": [
            "/assets/img/listing/img1.png",
            "/assets/images/products/clothes/2.png",
            "/assets/images/products/clothes/3.png",
            "/assets/images/products/clothes/4.png"
        ],
        "element": "Dark",
        "type": "Attack",
        "grade": "5",
        "user": {
            "name": "Hung Nguyen",
            "images": [
                "/assets/img/man1.png",
                "/assets/images/products/clothes/2.png",
                "/assets/images/products/clothes/3.png",
                "/assets/images/products/clothes/4.png"
            ]
        },
        "customerName": "test",
        "paymentState": "Paid using Paypal",
        "created": {
            "$date": "2022-12-10T04:27:34.102Z"
        },
        "createdBy": "test",
        "modifiedBy": "Hung Nguyen",
        "status": "Open",
        "active": true,
        "FreeWiFi": true,
        "Parking": true,
        "FitnessCenter": true,
        "NonSmokingRooms": true,
        "AirportShuttle": true,
        "AirConditioning": true,
        "Events": true,
        "FriendlyWorkspace": true,
        "SidebarWidgetsBookingForm": true,
        "SidebarWidgetsPriceRange": true,
        "SidebarWidgetsInstagram": true,
        "__v": 0,
        "address": "",
        "city": "hochiminh",
        "keywords": "",
        "modified": {
            "$date": "2022-12-10T15:59:53.887Z"
        }
    },
    {
        "_id": {
            "$oid": "63a04bb9efb7fff8d5cbc58d"
        },
        "name": "Ai sau đây là thợ săn tiền thưởng?",
        "title": "Ai sau đây là thợ săn tiền thưởng?",
        "keywords": "Fawkes - Đánh bại cái chết",
        "city": "hochiminh",
        "address": "",
        "category": "afkarena",
        "subCategory": "other",
        "slug": "ai-sau-đây-là-thợ-săn-tiền-thưởng?",
        "price": 1,
        "description": null,
        "details": "",
        "images": [],
        "thumbImage": [],
        "backgroundImages": [
            "assets/img/listing/img8.jpg"
        ],
        "carouselImages": [],
        "galleryThumbnails": [],
        "sliderImages": [],
        "element": null,
        "type": null,
        "grade": null,
        "created": {
            "$date": "2022-12-19T11:32:09.106Z"
        },
        "createdBy": "HN",
        "status": "Pending",
        "active": true,
        "__v": 0
    },
    {
        "_id": {
            "$oid": "63a04c25efb7fff8d5cbc593"
        },
        "name": "Estrilda - Hiệp sĩ dũng cảm trở thành hiệp sĩ năm bao nhiều tuổi?",
        "title": "Estrilda - Hiệp sĩ dũng cảm trở thành hiệp sĩ năm bao nhiều tuổi?",
        "keywords": "16",
        "city": "hochiminh",
        "address": "",
        "category": "realestate",
        "subCategory": "hotels",
        "slug": "estrilda---hiệp-sĩ-dũng-cảm-trở-thành-hiệp-sĩ-năm-bao-nhiều-tuổi?",
        "price": 1,
        "description": null,
        "details": "",
        "images": [],
        "thumbImage": [],
        "backgroundImages": [
            "assets/img/listing/img8.jpg"
        ],
        "carouselImages": [],
        "galleryThumbnails": [],
        "sliderImages": [],
        "element": null,
        "type": null,
        "grade": null,
        "created": {
            "$date": "2022-12-19T11:33:57.543Z"
        },
        "createdBy": "HN",
        "status": "Pending",
        "active": true,
        "__v": 0
    }
]